/*eslint-disable no-undef*/
/*global translate*/
import { connect } from 'react-redux'
import React, { Component, Fragment, useState } from 'react'
import { FixedSizeList, VariableSizeList } from 'react-window';
global.isclient && require('./rxAccountInfo.css')
const { rxsetLocal, rxgetLocal } = global.rootRequire('classes/request')
const { rxaget, rxChangeSlug, stringToColour, autoConvertTime, subString, changeColorSVG, isLeaderCheck } = global.rootRequire('classes/ulti')
const { checkBlock, checkNameGroup, checkAvatarGroup, checkNameContact, checkNameUser, updateUsersOnline, getNumMemberOnl, changeColorAva, textAva } = global.rootRequire('classes/chat')

const { netaMediaAdd, netaMediaDelMulti, netaGroupsUpdate, netaGroupsRemove, chooseGroupAction, changeStatusLoadMess, netaAuthSettingUpdate, clickPopup, clickCall, updateRecentContactGroups, netaAuthSettingSoundUpdate, updateRecentSearchGroups, changeGroupFunc, updateListPollState } = global.rootRequire('redux')
const RxImageGallery = global.rootRequire('components/shares/rxImageGallery').default
const OnOffUser = global.rootRequire('components/shares/rxOnOffUser').default
const OnOffGroup = global.rootRequire('components/shares/rxOnOffGroup').default
const RxInfoUser = global.rootRequire('components/shares/rxNewUserInfo').default
const RxPollList = global.rootRequire('components/shares/pollComponent/pollList/poll_list').default

const rxio = global.rootRequire('classes/socket').default
const chatDB = global.rootRequire('classes/indexedDB').default

const worker = global.rootRequire('classes/globalUser')
const workerUnread = global.rootRequire('classes/globalUnread')
let zget = global.rxu.get

let timeout = null
function SearchUserName({ value = "", onChange, theme }) {
  const [text, setText] = useState(value)

  function updateSearch(event) {
    setText(event.target.value)
    try {
      let strText = event.target.value
      if (timeout) {
        clearTimeout(timeout)
      }
      if (strText.length === 0) {
        onChange(strText)
      } else {
        timeout = setTimeout(function () {
          if (typeof onChange === 'function' && strText) {
            onChange(strText)
          }
        }, 500);
      }
    } catch (e) { }
  }

  return (
    <div className='popup_choose_leader_search_area'>
      <div className='popup_choose_leader_icon_search_area'>
        <img className='popup_choose_leader_icon_search filter_img_class' src={changeColorSVG('./images/default/icons/search-active.svg')} alt='' />
      </div>
      <input type='search' maxLength='30' id='newgroup_search_input' placeholder={translate("Search")} onChange={updateSearch} value={text} autoComplete='off'
        className={theme === 'darkTheme' ? 'popup_choose_leader_search_input darkThemeInput' : 'popup_choose_leader_search_input lightThemeInput'}>
      </input>
    </div>

  )
}

class RxAccountInfo extends Component {
  constructor(props, context) {
    super(props, context)
    this.state = {
      group: JSON.parse(JSON.stringify(rxaget(this.props, 'rxgroup.group', {}))),
      images: [],
      videos: [],
      files: [],
      tabactive: 'images',
      paging_page: 0,
      paging_size: 50,
      block_scroll: false,
      arrData: [],
      doneBtnClick: false,
      closeBtnClick: false,
      displayLeaveGroupScreen: false,
      leaveGroup_okBtnClick: false,
      displaySelectManagerScreen: false,
      displayGroupList: true,
      groupsMemberTemp: rxaget(this.props, 'rxgroupsMember.group', {}),
      group_id: '',
      isShowPopUp: false,
      admin_uins_index: rxaget(this.props, 'rxgroup.group.admin_uins', {}).length - 1,
      groupsNChat: [],
      groupsNChatOrigin: [],
      groupsNChatChecked: [],
      countMemberOnl: 0,
      groupsTemp: [],
      chooseLeader_groupsTemp: [],
      arrAdminsTemp: [],
      arrAdminMemberChecked: [],
      leaderMemberChecked: '',
      clickAddMemberBtn: false,
      lg_chooseLeader_groupsTemp: [],
      lg_leaderMemberChecked: '',
      groupNameValue: '',
      groupDescValue: '',
      theInputFileKey: new Date().getTime(),
      click_lg_chooseLeader_okBtn: false,
      loadingMedia: true,
      // notificationStatus :JSON.parse(rxgetLocal('netaNotificationStatus'))
      notificationStatus: global.rxu.json(rxgetLocal('netaNotificationStatus'), {}) || {},
      usersStatus: {},
      flagCopyLink: false,
      isBlocked: false,
      groupLink: '',
      searchName: '',
      infoUserScreen: false,
      infoUserId: 0,
      flagPollList: false,
      flagShowListAdmin: false,
      flagShowPopupAddAdmin: false,
      partnerProfile: {}//2: customer, 1: sale, 0: no info
    }

    this.blockDownload = false

    this.userid = rxaget(this.props, 'netaauth.user.id', '')
    // const contactsUsers = []
    // if (this.users && Object.keys(this.users).length > 0) {
    //   for (const userid of Object.keys(this.users)) {
    //     let arrgroup = rxaget(this.props, 'rxgroup.group.occupants_uins', [])
    //     if (userid !== this.userid && arrgroup.indexOf(userid) === -1 ) {
    //       contactsUsers.push(this.users[userid])
    //     }
    //   }
    //   this.state.groupsNChat = this.state.groupsNChatOrigin = contactsUsers
    // }
    this.controller = {}
    this.keyClickFunction = this.keyClickFunction.bind(this);
    this.uploadFileImages = this.uploadFileImages.bind(this)

    this.token = rxaget(this.props, 'netaauth.user.token', '')
    this.user = rxaget(this.props, 'netaauth.user', {})

    this.users = worker.users

    this.netaContact = rxaget(this.props, 'netaContact', {})
    this.downloadFile = this.downloadFile.bind(this)
    this.doneAccountInfo = this.doneAccountInfo.bind(this)
    this.chooseLeader_okBtnClick = this.chooseLeader_okBtnClick.bind(this)
    this.removeMember = this.removeMember.bind(this)
    this.onChangeNotiGroup = this.onChangeNotiGroup.bind(this)
    this.onClickBlockContact = this.onClickBlockContact.bind(this)

    this.rowMember = this.rowMember.bind(this)
    this.rowAdmin = this.rowAdmin.bind(this)

    // this.state.disableNotiSound = false
    let netaAuthSetting = JSON.parse(localStorage.getItem('netaAuthSetting') || `{"groups":{}}`)
    let disableNoti
    let disableNotiSound
    if (this.state.group.group_id && netaAuthSetting.groups[Number(this.state.group.group_id)]) {
      if (netaAuthSetting.groups[Number(this.state.group.group_id)].disableNoti) {
        disableNoti = true
      } else {
        disableNoti = false
      }

      if (netaAuthSetting.groups[Number(this.state.group.group_id)].disableNotiSound) {
        disableNotiSound = true
      } else {
        disableNotiSound = false
      }

    } else {
      disableNoti = false
      disableNotiSound = false
    }
    this.state.disableNoti = disableNoti
    this.state.disableNotiSound = disableNotiSound

    // { type: 0,  Id: '', department: '', email: '', full_name: '', tel: '', username: '', work_place: '', customer_id: ''}

    this.arrDefaultStaff = [{ name: 'Email', key: 'email' }, { name: 'Phone', key: 'tel' }, { name: 'Department', key: 'department' }, { name: 'Work Place', key: 'work_place' }]
    this.arrDefaultCustomer = [{ name: 'Customer Id', key: 'customer_id' }, { name: 'Your Mission', key: 'task' }]
    this.state.group.occupants_uins = this.sortGroupListMember(this.state.group)
  }

  componentWillUnmount() {
    document.removeEventListener("keydown", this.keyClickFunction, false);
  }

  componentDidMount() {
    let pollListStatus = rxaget(this.props, 'rxPollListState.status', false)
    this.checkPollListState(pollListStatus)
    let isBlocked = checkBlock(this.state.group, this.userid)
    if (isBlocked !== this.state.isBlocked) {
      this.setState({ isBlocked })
    }
    let occupants_uins = this.state.group.occupants_uins
    this.loadGroupsTemp(this.state.group, this.users)
    document.addEventListener("keydown", this.keyClickFunction, false);
    const contactsUsers = []
    if (this.users && Object.keys(this.users).length > 0) {
      let arrgroup = rxaget(this.props, 'rxgroup.group.occupants_uins', [])
      for (const userid of Object.keys(this.users)) {
        if (
          userid !== this.userid &&
          arrgroup.indexOf(userid) === -1
        )
          contactsUsers.push(this.users[userid])
      }
      this.setState({
        groupsNChat: contactsUsers,
        groupsNChatOrigin: contactsUsers
      })
    }
    this.preGetMedia(rxaget(this.props, 'netaMedia', {}), rxaget(this.state.group, 'group_id', ''))

    const { isChange, usersStatus, countMemberOnl } = updateUsersOnline(occupants_uins, this.state.countMemberOnl, this.state.usersStatus)
    if (isChange) this.setState({ isChange: isChange, usersStatus: usersStatus, countMemberOnl: countMemberOnl })

    rxio.getUpdateGroup((data) => {
      let groupObj = this.state.group
      if (groupObj.group_id === data.group_id) {
        let occupantsUinsTmp = groupObj['occupants_uins'].concat(data.push_all)
        groupObj['occupants_uins'] = Array.from(new Set(occupantsUinsTmp))
        this.loadGroupsTemp(groupObj, this.users)
        // this.props.chooseGroupAction(groupObj) 
        this.props.netaGroupsUpdate(Number(groupObj.group_id), groupObj)
        this.setState({ group: groupObj })
      }
    })

    this.fetchProfile()
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    let pollListStatus = rxaget(nextProps, 'rxPollListState.status', false)
    if (pollListStatus) {
      this.checkPollListState(pollListStatus)
    }
    let disableNoti
    let disableNotiSound
    let netaAuthSetting = JSON.parse(localStorage.getItem('netaAuthSetting') || `{"groups":{}}`)
    if (this.state.group.group_id && netaAuthSetting.groups[Number(this.state.group.group_id)]) {
      if (netaAuthSetting.groups[Number(this.state.group.group_id)].disableNoti) {
        disableNoti = true
      } else {
        disableNoti = false
      }

      if (netaAuthSetting.groups[Number(this.state.group.group_id)].disableNotiSound) {
        disableNotiSound = true
      } else {
        disableNotiSound = false
      }
    } else {
      disableNoti = false
      disableNotiSound = false
    }
    if (disableNoti !== this.state.disableNoti) {
      this.setState({ disableNoti: disableNoti })
    }
    if (disableNotiSound !== this.state.disableNotiSound) {
      this.setState({ disableNotiSound: disableNotiSound })
    }

    if (nextProps.usersStatus) {
      const { isChange, usersStatus, countMemberOnl } =
        updateUsersOnline(this.state.group.occupants_uins, this.state.countMemberOnl, nextProps.usersStatus, this.state.usersStatus)
      if (isChange) this.setState({ isChange: isChange, usersStatus: usersStatus, countMemberOnl: countMemberOnl })
    }

    if (rxaget(this.state.group, 'group_id', '') !== nextProps.rxgroup.groupid) {
      this.setState({ closeBtnClick: false, doneBtnClick: false })
    }
    if (nextProps.user.users && JSON.stringify(nextProps.user.users) !== JSON.stringify(this.users)) {
      let occupants_uins = nextProps.rxgroup.group.occupants_uins || []
      // this.users = rxaget(nextProps, 'user.users', {}) || {}
      this.loadGroupsTemp(rxaget(nextProps, 'rxgroup.group', {}), this.users)
    }
    if (rxaget(nextProps, 'rxgroup.groupid', '') !== rxaget(this.state.group, 'group_id', '')) {
      if (this.controller[rxaget(this.state.group, 'group_id', '')]) {
        this.controller[rxaget(this.state.group, 'group_id', '')].abort();
        // console.log("abort", rxaget(this.state.group, 'group_id', ''))
        delete this.controller[rxaget(this.state.group, 'group_id', '')]
      }
      this.preGetMedia(rxaget(nextProps, 'netaMedia', {}), rxaget(nextProps, 'rxgroup.groupid', ''))
    }
    if (nextProps.rxgroup.group && JSON.stringify(nextProps.rxgroup.group) !== JSON.stringify(this.state.group)) {
      let occupants_uins = nextProps.rxgroup.group.occupants_uins || []
      this.loadGroupsTemp(rxaget(nextProps, 'rxgroup.group', {}), this.users)
      const newgroup = JSON.parse(JSON.stringify(nextProps.rxgroup.group))
      let netaAuthSetting = JSON.parse(localStorage.getItem('netaAuthSetting') || `{"groups":{}}`)
      let disableNoti = false
      if (newgroup.group_id && netaAuthSetting.groups[Number(newgroup.group_id)]
        && netaAuthSetting.groups[Number(newgroup.group_id)].disableNoti)
        disableNoti = true

      const { isChange, usersStatus, countMemberOnl } = updateUsersOnline(occupants_uins, this.state.countMemberOnl, this.state.usersStatus)
      if (isChange) this.setState({ isChange: isChange, usersStatus: usersStatus, countMemberOnl: countMemberOnl })

      newgroup.occupants_uins = this.sortGroupListMember(newgroup)

      this.setState({ group: newgroup, disableNoti: disableNoti, partnerProfile: {} }, () => {
        this.netaContact = rxaget(this.props, 'netaContact', {})
        this.fetchProfile()
      })
    }
    if (nextProps.rxgroup && nextProps.rxgroup.group) {
      let isBlocked = checkBlock(nextProps.rxgroup.group, this.userid)
      if (isBlocked !== this.state.isBlocked) {
        this.setState({ isBlocked })
      }
    }

    if (rxaget(nextProps, 'netaMedia.status', '') !== rxaget(this.props, 'netaMedia.status', '') && rxaget(nextProps, 'netaMedia.change', '') !== '') {
      let arrData = this.state.arrData
      let mediaObj = arrData.find(o => o.url === rxaget(nextProps, 'netaMedia.change', ''))
      if (!mediaObj) {
        try {
          this.preGetMedia(rxaget(nextProps, 'netaMedia', {}), rxaget(this.state.group, 'group_id', ''))
        } catch (e) { }
      }
    }

  }

  shouldComponentUpdate(nextProps, nextState) {
    let isRerender = false
    if (JSON.stringify(nextState) !== JSON.stringify(this.state))
      isRerender = true
    else if (nextProps.rxgroup && JSON.stringify(nextProps.rxgroup.group) !== JSON.stringify(this.state.group))
      isRerender = true
    return isRerender
  }

  sortGroupListMember(group) {
    let arrUser = []
    for (let uid of group.occupants_uins) {
      let userInfo = worker.users[uid]
      let userName = this.getNameUser(userInfo)
      arrUser.push({
        uid: uid,
        name: (userName) ? userName.charAt(0).toLowerCase() : ''
      })
    }
    return this.sortByVietnameseAlphabet(arrUser)
  }

  sortByVietnameseAlphabet(arr) {
    const vietnameseAlphabet = ["a", "ă", "â", "b", "c", "d", "đ", "e", "ê", "f", "g", "h", "i", "j", "k", "l", "m", "n", "o", "ô", "ơ", "p", "q", "r", "s", "t", "u", "ư", "v", "w", "x", "y", "z"];

    let compareVietnameseStrings = (a, b) => {
      let indexA = vietnameseAlphabet.indexOf(a.name.toLowerCase());
      let indexB = vietnameseAlphabet.indexOf(b.name.toLowerCase());
      if (indexA === -1) indexA = 9999;
      if (indexB === -1) indexB = 9999;
      return indexA - indexB;
    }

    arr.sort(compareVietnameseStrings);

    return arr.map(u => u.uid)
  }



  preGetMedia(netaMedia, group_id) {
    var arrData = []
    if (netaMedia && netaMedia.data && netaMedia.data[group_id]) {
      const objMedia = JSON.parse(JSON.stringify(netaMedia.data[group_id]))
      if (objMedia && objMedia.images) {
        for (const key of Object.keys(objMedia.images || {})) {
          if (objMedia.images[key]) { arrData.push(objMedia.images[key]) }
        }
      }
    }
    arrData.sort((a, b) => (a.msg_create_at > b.msg_create_at) ? -1 : ((b.msg_create_at > a.msg_create_at) ? 1 : 0))
    this.setState({
      loadingMedia: true, arrData: arrData,
      block_scroll: false, paging_page: 0
    }, () => this.loadMediaStatic())
  }

  lg_chooseLeader(ele) {
    this.setState({ lg_leaderMemberChecked: ele.id })
  }

  chooseLeader(ele) {
    this.setState({ leaderMemberChecked: ele.id })
  }

  chooseAdmin(e, ele) {
    let arrAdminMember = this.state.arrAdminMemberChecked
    let findIndex = arrAdminMember.findIndex(object => {
      return object.id === ele.id;
    });

    if (findIndex !== -1) {
      arrAdminMember.splice(findIndex, 1)
    } else {
      arrAdminMember.push(ele)
    }

    this.setState({ arrAdminMemberChecked: arrAdminMember }, () => { })
  }

  isLeader(eleId) {
    if (eleId) {
      let group = this.state.group
      return isLeaderCheck(eleId.toString(), group)
    }

  }

  onChangeSearch_chooseLeader(e) {
    let value = e.target.value
    let arrGroups
    // if (value.startsWith('0')) {
    //   value = value.replace(value.charAt(0), '+84')
    // }
    if (e.target.value.length > 0) {
      arrGroups = this.state.groupsTemp.filter(o => (rxChangeSlug(checkNameUser(o)).indexOf(rxChangeSlug(value)) !== -1 || rxChangeSlug(o.phone).indexOf(rxChangeSlug(value)) !== -1))
    } else {
      value = ''
      arrGroups = this.state.groupsTemp.filter(o => rxChangeSlug(checkNameUser(o)).indexOf(rxChangeSlug(value)) !== -1)
    }
    this.setState({ chooseLeader_groupsTemp: arrGroups })
  }

  fetchImage(src, callback) {
    const timenow = Math.floor(Date.now() / 1000)
    try {
      let timeCreateImg = (typeof this.checkImage[src] !== 'undefined') ? rxaget(this.checkImage[src], 'created_at', 0) : 0
      if (!this.checkImage[src] || ((timenow - timeCreateImg) > 43200 && timeCreateImg > 0)) {
        fetch(src, { headers: { 'TC-Token': this.token }, redirect: 'follow' })
          .then(res => {
            if (res && res.redirected && res.url && src) {
              try {
                callback(res.url)
                this.props.netaBlobsUpdate(src, res.url)
              } catch (e) {
                callback('')
              }
            } else {
              callback('')
            }
          })
      } else {
        callback(rxaget(this.checkImage[src], 'link', ''))
      }
    } catch (e) {
      callback('')
    }
  }

  async fetchProfile() {
    let group = this.state.group
    if (group && group.type === 3) {
      try {
        const partnerUin = global.rxu.array(rxaget(group, 'occupants_uins', [])).filter(ele => (ele.toString() !== this.userid.toString()))
        if (partnerUin.length > 0) {
          // let partnerUser = this.users[partnerUin[0].toString()]
          let partnerUser = await chatDB.users.get(Number(partnerUin[0]))
          if (partnerUser && partnerUser.phone && partnerUser.phone !== "") {
            let checked = true

            let checkContact = await chatDB.contacts.get(partnerUser.phone)

            // my is staff
            let partnerIsStaff = (partnerUser.phone.indexOf('ipa') !== -1 || partnerUser.phone.indexOf('pti') !== -1 || /^.{3}\\/.test(partnerUser.phone)) ? true : false

            if (checked) {
              let api_profile = global.rxu.config.base_api_neta + '/api/users/profile/' + encodeURI(partnerUser.phone)

              fetch(api_profile, {
                method: 'GET',
                headers: {
                  Accept: 'application/json',
                  'TC-Token': this.token,
                  Connection: 'Keep-Alive',
                  'Accept-Encoding': 'gzip'
                }
              }).then(res => res.json()).then((json) => {
                if (json && json.username) {
                  let partnerProfile = { type: 0, Id: '', department: '', email: '', full_name: '', tel: '', username: '', work_place: '', customer_id: '' }
                  partnerProfile = { ...partnerProfile, ...json };

                  if (json.user_type && json.user_type === 1) {
                    partnerProfile['type'] = 1
                  } else {
                    partnerProfile['type'] = 2
                  }

                  // if (partnerIsStaff && (rxaget(json, "customer_id", "") === "")) {
                  //   partnerProfile['type'] = 1 // staff
                  // } else {
                  //   partnerProfile['type'] = 2 // customer   
                  // }

                  this.setState({
                    partnerProfile: partnerProfile
                  })
                }
              }).catch(error => {
                console.log("fetch Profile error")
              })
            }
          }
        }
      } catch (e2) { }
    }
  }

  onChangeSearch_lg_chooseLeader(e) {
    let value = e.target.value
    let arrGroups
    // if (value.startsWith('0')) {
    //   value = value.replace(value.charAt(0), '+84')
    // }
    if (e.target.value.length > 0) {
      arrGroups = this.state.groupsTemp.filter(o => (rxChangeSlug(checkNameUser(o)).indexOf(rxChangeSlug(value)) !== -1 || rxChangeSlug(o.phone).indexOf(rxChangeSlug(value)) !== -1))
    } else {
      value = ''
      arrGroups = this.state.groupsTemp.filter(o => rxChangeSlug(checkNameUser(o)).indexOf(rxChangeSlug(value)) !== -1)
    }
    this.setState({ lg_chooseLeader_groupsTemp: arrGroups })
  }

  onChangeSearchNChat(e) {
    let value = e.target.value
    let arrGroups
    // if (value.startsWith('0')) {
    //   value = value.replace(value.charAt(0), '+84')
    // }
    if (value) {
      arrGroups = this.state.groupsNChatOrigin.filter(member => (rxChangeSlug(checkNameUser(member)).indexOf(rxChangeSlug(value)) !== -1 || rxChangeSlug(member.phone).indexOf(rxChangeSlug(value)) !== -1))
    } else {
      arrGroups = this.state.groupsNChatOrigin
    }
    this.setState({
      groupsNChat: arrGroups,
    }, () => {
      const images = document.getElementsByClassName('ava-useravatar')
      if (images && images.length > 0) {
        for (let i = 0; i < images.length; i++) {
          const valueAttr = images[i].getAttribute('data-id')
          if (valueAttr && valueAttr.indexOf('userava') !== -1) {
            const userid = valueAttr.replace('userava', '')
            if (userid) {
              const avatar_url = global.rxu.config.get_avatar + userid
              this.fetchImage(avatar_url, (data) => {
                if (data) {
                  images[i].src = data
                }
              })
            }
          }
        }
      }
    })
  }

  leaveGroupBtnClick() {
    let groupObj = this.state.group
    if (groupObj && groupObj.occupants_uins && groupObj.occupants_uins.constructor === Array) {
      workerUnread.initUnread(groupObj.group_id, '-1')
      let user = rxaget(this.props, 'netaauth.user', {})
      let contactsUsers = []
      let arrUins = rxaget(groupObj, 'occupants_uins', []).filter(u => u.toString() !== this.userid.toString())
      if (arrUins && arrUins.length > 0) {
        arrUins = arrUins.map(uid => Number(uid))
        chatDB.users.bulkGet(arrUins).then(contactsUsers => {
          contactsUsers = contactsUsers.filter(Boolean)
          this.props.clickPopup('leave_group', { data: { groups: contactsUsers, user: user, group: groupObj } }, (data) => {
            if (data) {
              this.funcChooseLeader(data, groupObj)
            } else {
              this.leaveGroup()
            }
          })

        }).catch(e => {
          console.log(e)
        })
      }
    }
  }

  funcChooseLeader(leaderChecked, groupObj) {
    let leaderMemberChecked = leaderChecked
    let index = groupObj.admin_uins.findIndex(uid => uid === this.userid.toString())

    groupObj.admin_uins[index] = leaderMemberChecked.toString()
    const params = {
      group_id: Number(groupObj.group_id),
      admin_uins: groupObj.admin_uins
    }

    rxio.addAdmin(params, (data) => {
      if (data) {
        try {
          this.setState({ closeBtnClick: false, doneBtnClick: false })
          const paramsCreateMess = {
            group_id: Number(this.state.group.group_id),
            type: 6,
            version: 1,
            nonce: (Math.floor(Date.now()) * 1000).toString(),
            sender_name: rxaget(this.user, 'name', ''),
            attachments: JSON.stringify({
              mediaType: 0,
              type: 'update_group',
              admin_uins: [groupObj.admin_uins[index]]
            }).replace(/"/g, '\\"'),
            "is_encrypted": false, "mentioned_all": false
          }
          rxio.createMessage(paramsCreateMess, (dataMess) => {
            if (dataMess) {
              groupObj.admin_uins = groupObj.admin_uins[index]
              groupObj.last_message = dataMess.message
              groupObj.last_message_id = dataMess.last_message_id

              try {
                if (dataMess.message.message_id) {
                  chatDB.groups.get({ group_id: groupObj.group_id.toString() }).then(groupInDB => {
                    if (groupInDB) {
                      let paramsUpdateGroup = {
                        admin_uins: groupObj.admin_uins,
                        last_message: dataMess.message,
                        last_message_id: dataMess.message.message_id,
                        last_sort: '1' + groupInDB.flagDraf + groupInDB.flagPin + dataMess.message.created_at,
                        count_unread: 0
                      }
                      workerUnread.initUnread(rxaget(groupInDB, 'group_id', '').toString(), '-1')
                      chatDB.groups.update(rxaget(groupInDB, 'group_id', '').toString(), paramsUpdateGroup).then(o => {
                        this.props.changeGroupFunc()
                      }).catch(e => { })
                    }
                  })
                }
              } catch (e1) {
                console.log(e1)
              }

              this.props.changeStatusLoadMess()
              this.props.chooseGroupAction(groupObj)
              this.leaveGroup()
            }
          })
        } catch (error) { console.log("addAdmin", error) }
      }
    })
    // this.setState({ displayLeaveGroupScreen: false })
  }

  leaveGroup_cancelBtnClick() {
    this.setState({ displayLeaveGroupScreen: false })
  }

  leaveGroup_okBtnClick() {
    if (this.state.group.admin_uins) {
      let admin_unis = this.state.group.admin_uins
      let isOpen = !admin_unis.some(i => (this.userid.toString() !== i.toString() && this.state.group.occupants_uins.indexOf(i.toString()) >= 0))

      if (isOpen) {
        this.setState({ displaySelectManagerScreen: true })
      }
      else this.leaveGroup()
    }
  }

  chooseLeader_okBtnClick() {
    let groupObj = rxaget(this.props, 'rxgroup.group', {})
    let leaderMemberChecked = this.state.leaderMemberChecked
    let index = this.state.admin_uins_index

    groupObj.admin_uins[index] = leaderMemberChecked.toString()
    let owner_uin = Number(groupObj.admin_uins[index])
    if (groupObj.admin_uins[index]) {
      const msg = {
        group_id: Number(groupObj.group_id),
        name: "",
        owner_uin: owner_uin
      }
      rxio.socket.emit("update_group", msg, (data) => {
        if (data && data.result === 0) {
          try {
            this.setState({
              closeBtnClick: false,
              doneBtnClick: false,
              leaderMemberChecked: '',
            })

            const arrUsers = this.users
            const user = rxaget(this.props, 'netaauth.user', {})
            const objUser = arrUsers[user.id.toString()]
            const paramsCreateMess = {
              group_id: Number(this.state.group.group_id),
              type: 6,
              version: 1,
              nonce: (Math.floor(Date.now()) * 1000).toString(),
              sender_name: rxaget(objUser, 'full_name', ''),
              attachments: JSON.stringify({
                mediaType: 0, type: 'update_group',
                owner_uin: owner_uin
              }).replace(/"/g, '\\"'),
              "is_encrypted": false, "mentioned_all": false
            }

            rxio.createMessage(paramsCreateMess, (dataMess) => {
              if (dataMess) {
                let groupObj = this.state.group
                // groupObj.owner_uin = owner_uin
                // groupObj.last_message = dataMess.message
                // groupObj.last_message_id = dataMess.last_message_id
                // this.props.changeStatusLoadMess()
                // this.props.chooseGroupAction(groupObj)
                // this.props.netaGroupsUpdate(Number(groupObj.group_id), groupObj)
                this.handleMessage(dataMess.message, true, 'footer')

                chatDB.groups.get({ group_id: rxaget(groupObj, 'group_id', '').toString() }).then(groupInDB => {
                  if (groupInDB && dataMess && dataMess.message) {
                    groupInDB.last_message = dataMess.message
                    groupInDB.last_message_id = dataMess.message.message_id
                    groupInDB.last_sort = '1' + groupInDB.flagDraf + groupInDB.flagPin + dataMess.message.created_at
                    groupInDB.count_unread = 0
                    groupInDB.owner_uin = owner_uin.toString()

                    let arrAdminUins = rxaget(groupInDB, 'admin_uins', [])
                    if (arrAdminUins.indexOf(owner_uin.toString()) === -1) {
                      arrAdminUins.push(owner_uin.toString())
                    }
                    groupInDB.admin_uins = arrAdminUins

                    workerUnread.initUnread(rxaget(groupInDB, 'group_id', '').toString(), '-1')

                    chatDB.groups.put(groupInDB, groupInDB.group_id).then((updated) => {
                      this.setState({
                        group: groupInDB
                      })
                      this.props.changeGroupFunc()
                      this.props.chooseGroupAction(groupInDB)
                    })
                  }
                })
              }
            })
          } catch (error) { console.log("addAdmin", error) }
        }
      })
    }
  }

  lg_chooseLeader_okBtnClick() {
    let groupObj = rxaget(this.props, 'rxgroup.group', {})
    let leaderMemberChecked = this.state.lg_leaderMemberChecked
    let index = this.state.admin_uins_index

    // groupObj.admin_uins[index] = leaderMemberChecked.toString()
    const params = {
      group_id: Number(groupObj.group_id),
      admin_uins: [leaderMemberChecked.toString()]
    }
    rxio.addAdmin(params, (data) => {

      if (data) {
        try {
          this.setState({
            closeBtnClick: false,
            doneBtnClick: false,
            leaderMemberChecked: ''
          })
          const arrUsers = this.users
          const user = rxaget(this.props, 'netaauth.user', {})
          const objUser = arrUsers[user.id.toString()]
          const paramsCreateMess = {
            group_id: Number(this.state.group.group_id),
            type: 6,
            version: 1,
            nonce: (Math.floor(Date.now()) * 1000).toString(),
            sender_name: rxaget(objUser, 'full_name', ''),
            attachments: JSON.stringify({
              mediaType: 0, type: 'update_group',
              admin_uins: [groupObj.admin_uins[index]]
            }).replace(/"/g, '\\"'),
            "is_encrypted": false, "mentioned_all": false
          }

          rxio.createMessage(paramsCreateMess, (dataMess) => {
            if (dataMess) {
              let groupObj = JSON.parse(JSON.stringify(this.state.group))
              groupObj.admin_uins = groupObj.admin_uins[index]
              groupObj.last_message = dataMess.message
              groupObj.last_message_id = dataMess.last_message_id
              this.props.changeStatusLoadMess()
              this.props.chooseGroupAction(groupObj)
              this.props.netaGroupsUpdate(Number(groupObj.group_id), groupObj)
              this.leaveGroup()
            }
          })
        } catch (error) { console.log("addAdmin", error) }
      }

    })
    this.setState({ displayLeaveGroupScreen: false })
  }

  leaveGroup() {
    let groupObj = this.state.group
    if (groupObj && groupObj.group_id) {
      if (rxio.connected) {
        const msgUpGroup = {
          group_id: Number(groupObj.group_id)
        }
        rxio.leaveGroup(msgUpGroup, (data) => {
          if (data && [0, 1].indexOf(data.result) !== -1) {
            this.setState({ displayLeaveGroupScreen: false }, () => {
              // this.props.netaGroupsRemove(groupObj.group_id)
              chatDB.groups.delete(groupObj.group_id).then(result => {
                this.props.changeGroupFunc()
                chatDB.groups.limit(1).toArray().then(o => {
                  if (o.length > 0) {
                    this.props.chooseGroupAction(o[0])
                  }
                })
              }).catch(e => { })


            })
          }
        })

      }
    }
  }

  getNameUser(user) {
    return (user && user.name_display) ? user.name_display : (user && user.full_name) ? user.full_name : (user && user.phone) ? user.phone : translate('Stranger')
  }

  handleMessage(data, scroll, cond) {
    let elem = document.getElementById('chat-value')
    if (elem) {
      elem.dispatchEvent(new CustomEvent('chatInput', { detail: { data: data, scroll: scroll, cond: cond } }))
    }
  }

  apiRemoveMember(mem, groupObj) {
    const msgUpGroup = {
      group_id: Number(groupObj.group_id),
      name: '',
      avatar_url: '',
      pull_all: [mem.id.toString()]
    }

    rxio.socket.emit('update_group', msgUpGroup, (data) => {
      try {
        const user = rxaget(this.props, 'netaauth.user', {})

        chatDB.users.get(Number(user.id)).then(u => {
          const paramsCreateMess = {
            group_id: Number(groupObj.group_id),
            type: 6,
            version: 1,
            sender_name: this.getNameUser(u),
            message: '',
            attachments: JSON.stringify({ removed_uin: mem.id.toString(), type: 'update_group' }).replace(/"/g, '\\"')

          }

          rxio.socket.emit('create_message', paramsCreateMess, (dataMess) => {
            if (dataMess) {
              this.handleMessage(dataMess.message, true, 'footer')

              chatDB.groups.get({ group_id: groupObj.group_id }).then(groupInDB => {
                if (groupInDB && dataMess && dataMess.message) {
                  groupInDB.last_message = dataMess.message
                  groupInDB.last_message_id = dataMess.message.message_id
                  groupInDB.last_sort = '1' + groupInDB.flagDraf + groupInDB.flagPin + dataMess.message.created_at
                  groupInDB.count_unread = 0
                  groupInDB.occupants_uins = groupInDB.occupants_uins.filter(uid => uid !== mem.id.toString())
                  if (groupInDB.removed_uins.constructor === Array) {
                    groupInDB.removed_uins.push(mem.id.toString())
                  }

                  workerUnread.initUnread(rxaget(groupInDB, 'group_id', '').toString(), '-1')

                  chatDB.groups.put(groupInDB, groupObj.group_id.toString()).then((updated) => {
                    this.setState({
                      group: groupInDB
                    })

                    this.props.changeGroupFunc()
                    this.props.chooseGroupAction(groupInDB)

                  });
                }
              })
            }
          })
        })
      } catch (e) {
        console.log(e)
      }
    })
  }

  removeMember(mem) {
    let groupObj = JSON.parse(JSON.stringify(this.state.group))
    if (rxio.connected && mem && mem.id) {
      let memUin = mem.id.toString()
      let adminUins = rxaget(groupObj, 'admin_uins', [])
      if (adminUins.indexOf(memUin) !== -1) {
        const msgUpGroup = {
          group_id: Number(groupObj.group_id),
          admin_uins: [mem.id.toString()]
        }
        rxio.socket.emit('delete_admin', msgUpGroup, (data) => {
          this.apiRemoveMember(mem, groupObj)
        })
      } else {
        this.apiRemoveMember(mem, groupObj)
      }
    }
  }

  removeAdmin(mem) {
    let groupObj = JSON.parse(JSON.stringify(this.state.group))
    if (rxio.connected) {
      const msgUpGroup = {
        group_id: Number(groupObj.group_id),
        admin_uins: [mem.id.toString()]
      }

      rxio.socket.emit('delete_admin', msgUpGroup, (data) => {
        try {
          const user = rxaget(this.props, 'netaauth.user', {})

          chatDB.users.get(Number(user.id)).then(u => {
            const paramsCreateMess = {
              group_id: Number(groupObj.group_id),
              type: 6,
              version: 1,
              sender_name: this.getNameUser(u),
              message: '',
              attachments: JSON.stringify({ deleted_admins: [mem.id.toString()], type: 'update_group' }).replace(/"/g, '\\"')
            }

            rxio.socket.emit('create_message', paramsCreateMess, (dataMess) => {
              if (dataMess) {
                this.handleMessage(dataMess.message, true, 'footer')

                chatDB.groups.get({ group_id: groupObj.group_id }).then(groupInDB => {
                  if (groupInDB && dataMess && dataMess.message) {
                    groupInDB.last_message = dataMess.message
                    groupInDB.last_message_id = dataMess.message.message_id
                    groupInDB.last_sort = '1' + groupInDB.flagDraf + groupInDB.flagPin + dataMess.message.created_at
                    groupInDB.count_unread = 0
                    groupInDB.admin_uins = groupInDB.admin_uins.filter(uid => uid !== mem.id.toString())


                    workerUnread.initUnread(rxaget(groupInDB, 'group_id', '').toString(), '-1')

                    chatDB.groups.put(groupInDB, groupObj.group_id.toString()).then((updated) => {
                      let arrAdminsTemp = this.state.arrAdminsTemp.filter(u => u.id.toString() !== mem.id.toString())

                      this.setState({
                        group: groupInDB,
                        arrAdminsTemp: arrAdminsTemp,
                      })

                      this.props.changeGroupFunc()
                      this.props.chooseGroupAction(groupInDB)
                    });
                  }
                })
              }
            })
          })

        } catch (e) {
          console.log(e)
        }
      })
    }
  }

  onClickAddAdminMember() {
    let groupObj = JSON.parse(JSON.stringify(this.state.group))
    let arrAdminChecked = this.state.arrAdminMemberChecked.map(u => u.id.toString())
    if (rxio.connected) {
      const msgUpGroup = {
        group_id: Number(groupObj.group_id),
        admin_uins: arrAdminChecked
      }

      rxio.socket.emit('add_admin', msgUpGroup, (data) => {
        try {
          const user = rxaget(this.props, 'netaauth.user', {})

          chatDB.users.get(Number(user.id)).then(u => {
            const paramsCreateMess = {
              group_id: Number(groupObj.group_id),
              type: 6,
              version: 1,
              sender_name: this.getNameUser(u),
              message: '',
              attachments: JSON.stringify({ added_admins: arrAdminChecked, type: 'update_group' }).replace(/"/g, '\\"')
            }

            rxio.socket.emit('create_message', paramsCreateMess, (dataMess) => {
              if (dataMess) {
                this.handleMessage(dataMess.message, true, 'footer')

                chatDB.groups.get({ group_id: groupObj.group_id }).then(groupInDB => {
                  if (groupInDB && dataMess && dataMess.message) {
                    groupInDB.last_message = dataMess.message
                    groupInDB.last_message_id = dataMess.message.message_id
                    groupInDB.last_sort = '1' + groupInDB.flagDraf + groupInDB.flagPin + dataMess.message.created_at
                    groupInDB.count_unread = 0

                    for (let adminid of arrAdminChecked) {
                      if (groupInDB.admin_uins.indexOf(adminid) === -1) {
                        if (adminid) {
                          groupInDB.admin_uins.push(adminid)
                        }
                      }
                    }

                    workerUnread.initUnread(rxaget(groupInDB, 'group_id', '').toString(), '-1')

                    chatDB.groups.put(groupInDB, groupObj.group_id.toString()).then((updated) => {
                      this.setState({
                        group: groupInDB,
                        flagShowPopupAddAdmin: false
                      })

                      this.props.changeGroupFunc()
                      this.props.chooseGroupAction(groupInDB)
                    });
                  }
                })
              }
            })
          })

        } catch (e) {
          console.log(e)
        }
      })
    }
  }

  onChangeNotiGroup() {
    try {
      let disableNoti = !this.state.disableNoti
      let groupObj = JSON.parse(JSON.stringify(this.state.group))
      let netaAuthSetting = JSON.parse(localStorage.getItem('netaAuthSetting') || `{"groups":{}}`)
      !netaAuthSetting.groups[Number(this.state.group.group_id)]
        && (netaAuthSetting.groups[Number(this.state.group.group_id)] = {})
      netaAuthSetting.groups[Number(this.state.group.group_id)].disableNoti = disableNoti
      // rxsetLocal('netaAuthSetting', JSON.stringify(netaAuthSetting))
      this.props.netaAuthSettingUpdate(netaAuthSetting)
      this.props.changeStatusLoadMess()
      this.props.chooseGroupAction(groupObj)
      this.setState({ disableNoti: disableNoti })
    } catch (error) { console.log("onChangeNotiGroup", error) }
  }
  onChangeNotiSoundGroup() {
    let disableNotiSound = !this.state.disableNotiSound
    let netaAuthSetting = JSON.parse(localStorage.getItem('netaAuthSetting') || `{"groups":{}}`)
    !netaAuthSetting.groups[Number(this.state.group.group_id)]
      && (netaAuthSetting.groups[Number(this.state.group.group_id)] = {})
    netaAuthSetting.groups[Number(this.state.group.group_id)].disableNotiSound = disableNotiSound
    this.props.netaAuthSettingSoundUpdate(netaAuthSetting)
    this.setState({ disableNotiSound: disableNotiSound })
  }

  onClickAddMember() {
    let groupObj = JSON.parse(JSON.stringify(this.state.group))
    let groupObjMemberIdArr = groupObj.occupants_uins
    let contactsUsers = []
    // if (this.users && Object.keys(this.users).length > 0) {
    //   console.log('00000000000111111111')
    //   for (const userid of Object.keys(this.users)) {
    //     if (!groupObjMemberIdArr.includes(userid.toString())) {
    //       contactsUsers.push(this.users[userid])
    //     }
    //   }
    //   console.log('111111111')
    //   this.setState({ groupsNChat: contactsUsers, groupsNChatChecked: [] }, () => {
    //     console.log('22222222222')
    let user = rxaget(this.props, 'netaauth.user', {})
    this.props.clickPopup('add_member', { data: { groups: contactsUsers, user: user, group: groupObj } }, (data) => {
      if (data && data.constructor === Array && data.length > 0) {
        this.onClickUpdateGroup(data)
      }
    }) //dispatch action 
    //   })
    // }
  }

  onChangeSearchMember(value) {
    let group = this.state.group
    if (!group.occupants_uins_origin) {
      group.occupants_uins_origin = group.occupants_uins
    }

    let arrUser = []
    for (let uid of group.occupants_uins_origin) {
      let userInfo = worker.users[uid]
      let userName = this.getNameUser(userInfo)
      if (userName.toLowerCase().indexOf(value.toLowerCase()) !== -1) {
        arrUser.push(uid)
      }
    }
    if (value) {
      group.occupants_uins = arrUser
    } else {
      group.occupants_uins = group.occupants_uins_origin
    }

    this.setState({
      group: group,
      searchName: value
    })
  }

  onClickBlockContact() {
    let group = this.state.group
    let isBlocked = this.state.isBlocked

    if ([1, 3].indexOf(isBlocked) !== -1) {
      rxio.unblockUser({ group_id: group.group_id, uni: group.partner_id }, (data) => {
        if (data && data.result === 0) {
          let blocked_uins = group.blocked_uins

          for (let i = 0; i < blocked_uins.length; i++) {
            if (blocked_uins[i] === group.partner_id) {
              blocked_uins.splice(i, 1)
            }
          }
          group.blocked_uins = blocked_uins

          chatDB.groups.update(rxaget(group, 'group_id', '').toString(), { blocked_uins: blocked_uins }).then(o => {
            this.props.changeGroupFunc()
          }).catch(e => { })

          this.props.chooseGroupAction(group)
        }
      })
    }
    if ([0, 2].indexOf(isBlocked) !== -1) {
      rxio.blockUser({ group_id: group.group_id, uni: group.partner_id }, (data) => {
        if (data && data.result === 0) {
          let blocked_uins = group.blocked_uins

          blocked_uins.push(group.partner_id)
          group.blocked_uins = blocked_uins

          chatDB.groups.update(rxaget(group, 'group_id', '').toString(), { blocked_uins: blocked_uins }).then(o => {
            this.props.changeGroupFunc()
          }).catch(e => { })

          this.props.chooseGroupAction(group)
        }
      })
    }

    this.setState({ displayAskBlock: false })
  }

  onClickUpdateGroup(groupsChecked = []) {
    let groupObj = JSON.parse(JSON.stringify(this.state.group))
    // let groupsChecked = groupsChecked || []
    // let clickAddMemberBtn = this.state.clickAddMemberBtn

    // let groupObjMemberIdArr = JSON.parse(JSON.stringify(groupObj.occupants_uins)) //mang id thanh vien dang co trong nhom
    // if (groupsChecked && groupsChecked.constructor === Array) {
    //   for (let i = 0; i < groupsChecked.length; i++) { //duyet toan bo mang duoc check
    //     groupObjMemberIdArr.push(String(groupsChecked[i]))
    //   }
    // }

    // console.log(clickAddMemberBtn, 'clickAddMemberBtn') //rõ ràng
    try {
      if (groupsChecked.length > 0) {
        let arrMember = groupsChecked.map(o => o.toString()) // danh sách thành viên được check
        if (groupObj && groupObj.group_id && arrMember.constructor === Array && arrMember.length > 0) {
          if (rxio.connected) {
            const msgUpGroup = {
              group_id: Number(groupObj.group_id),
              name: '',
              avatar_url: '',
              push_all: arrMember
            }
            rxio.updateGroup(msgUpGroup, (data) => {
              const arrUsers = this.users
              const user = rxaget(this.props, 'netaauth.user', {})
              const objUser = arrUsers[user.id.toString()]
              const paramsCreateMess = {
                group_id: Number(groupObj.group_id),
                type: 6,
                version: 1,
                sender_name: (objUser && objUser.full_name) ? objUser.full_name : '',
                message: '',
                attachments: JSON.stringify({ added_uins: arrMember, type: 'update_group' }).replace(/"/g, '\\"')
              }
              rxio.createMessage(paramsCreateMess, (dataMess) => {
                if (dataMess) {
                  this.handleMessage(dataMess.message, true, 'footer')

                  chatDB.groups.get({ group_id: groupObj.group_id }).then(groupInDB => {
                    if (groupInDB) {
                      groupInDB.last_message = dataMess.message
                      groupInDB.last_message_id = dataMess.message.message_id
                      groupInDB.last_sort = '1' + groupInDB.flagDraf + groupInDB.flagPin + dataMess.message.created_at
                      groupInDB.count_unread = 0
                      groupInDB.occupants_uins = [...groupInDB.occupants_uins, ...arrMember]

                      workerUnread.initUnread(rxaget(groupInDB, 'group_id', '').toString(), '-1')

                      chatDB.groups.put(groupInDB, groupObj.group_id.toString()).then((updated) => {
                        this.setState({
                          group: groupInDB
                        })

                        this.props.changeGroupFunc()
                        this.props.chooseGroupAction(groupInDB)

                      });
                    }
                  })
                }
              })
            })
          }
        }
      } else {
        alert(translate('Add Member Error'))
      }
    } catch (e) { }

    // this.setState({ clickAddMemberBtn: true })
  }

  closeAddMemberScreen() {
    this.clearSearchBox()
    this.setState({ addMemberScreen: false })
  }

  onClickAddMemberGroup(contact) {
    const groupsNChatChecked = JSON.parse(JSON.stringify(this.state.groupsNChatChecked))
    if (groupsNChatChecked.indexOf(contact.id) === -1) {
      groupsNChatChecked.push(contact.id)
    } else {
      groupsNChatChecked.splice(groupsNChatChecked.indexOf(contact.id), 1)
    }
    this.setState({ groupsNChatChecked })
  }

  lg_closeNewManager() {
    this.setState({ displaySelectManagerScreen: false })
  }

  dropDownListMemberClick() {
    if (this.state.displayGroupList === true) {
      this.setState({ displayGroupList: false })
    } else {
      this.setState({ displayGroupList: true })
    }
  }

  backBtnClickGroup() {
    this.setState({ doneBtnClick: false })
  }

  editAccountInfo() {
    this.setState({ doneBtnClick: true, groupNameValue: checkNameGroup(this.state.group, this.users, this.userid), groupDescValue: rxaget(this.state.group, 'description', '') }, () => {
      let group_id = zget(this.state.group, 'group_id', '')
      rxio.listGroupLink(group_id, (dataLink) => {
        if (dataLink && dataLink.links && dataLink.links.constructor === Array && dataLink.links.length > 0) {
          this.setState({ groupLink: dataLink.links[0] })
        }
      })
    })
  }

  btnRevokeLink() {
    let deepLinkUrl = this.state.groupLink
    try {
      let arrRegexStr = deepLinkUrl.split('/')
      if (arrRegexStr && arrRegexStr.length > 0) {
        let tokenStr = arrRegexStr[arrRegexStr.length - 1]
        rxio.revokeLink(tokenStr, (data) => {
          this.setState({ groupLink: '' })
        })
      }
    } catch (e) {
      console.log(e)
    }
  }

  doneAccountInfo() {
    try {
      if (this.state.groupNameValue !== checkNameGroup(this.state.group, this.users, this.userid) || this.state.groupDescValue !== rxaget(this.state.group, 'description', '')) {
        let newName = this.state.groupNameValue
        if (newName.search(/[\\]/) !== -1) {
          alert(translate('Group name contains invalid characters'))
        } else {
          this.setState({ doneBtnClick: false })
          if (this.state.group.type === 3) {
            const user = rxaget(this.props, 'netaauth.user', {})
            let groupObj = JSON.parse(JSON.stringify(this.state.group))
            groupObj.name = newName
            groupObj.group_name = newName
            groupObj.group_fullname = newName
            groupObj.last_message = {
              attachments: `{"updated_group_name":${newName},"mediaType":0,"type":"update_group"}`,
              group_id: Number(this.state.group.group_id),
              type: 6,
              sender_uin: user.id.toString()
            }
            let netaAuthSetting = JSON.parse(localStorage.getItem('netaAuthSetting') || `{"groups":{}}`)
            !netaAuthSetting.groups[Number(groupObj.group_id)]
              && (netaAuthSetting.groups[Number(groupObj.group_id)] = {})
            netaAuthSetting.groups[Number(groupObj.group_id)].name = newName

            let partner_id = groupObj.partner_id || groupObj.occupants_uins[0]
            !netaAuthSetting.groups[Number(partner_id)]
              && (netaAuthSetting.groups[Number(partner_id)] = {})
            netaAuthSetting.groups[Number(partner_id)].name = newName

            rxsetLocal('netaAuthSetting', JSON.stringify(netaAuthSetting))
            this.props.changeStatusLoadMess()
            this.props.chooseGroupAction(groupObj)
            // this.props.netaGroupsUpdate(Number(groupObj.group_id), groupObj)
          }
          else
            if (rxio.connected) {
              const netaRecentSearchGroups = global.rxu.json(rxgetLocal('netaRecentSearchGroups'), {}) || {}
              let msg = {
                group_id: Number(this.state.group.group_id)
              }

              let newAttachments = {
                mediaType: 0, type: "update_group"
              }

              if (this.state.groupNameValue !== checkNameGroup(this.state.group, this.users, this.userid)) {
                msg['name'] = newName
                newAttachments['updated_group_name'] = newName
              }

              let descGroup = this.state.groupDescValue
              if (this.state.groupDescValue !== rxaget(this.state.group, 'description', '') && descGroup) {
                msg['description'] = descGroup
              }

              rxio.socket.emit("update_group", msg, (data) => {
                if (data && data.result === 0) {
                  try {
                    const arrUsers = this.users
                    const user = rxaget(this.props, 'netaauth.user', {})
                    const objUser = arrUsers[user.id.toString()]
                    let msg = {
                      group_id: Number(this.state.group.group_id),
                      type: 6,
                      version: 1,
                      nonce: (Math.floor(Date.now()) * 1000).toString(),
                      sender_name: rxaget(objUser, 'full_name', ''),
                      attachments: JSON.stringify(newAttachments).replace(/"/g, '\\"'),
                      "is_encrypted": false, "mentioned_all": false
                    }
                    rxio.socket.emit('create_message', msg, (dataMess) => {
                      if (dataMess) {
                        let groupObj = JSON.parse(JSON.stringify(this.state.group))
                        groupObj.name = newName
                        groupObj.group_name = newName
                        groupObj.group_fullname = newName
                        groupObj.last_message = dataMess.message
                        groupObj.last_message_id = dataMess.last_message_id
                        this.props.changeStatusLoadMess()
                        this.handleMessage(dataMess.message, true, 'footer')
                        let paramsUpdateGroup = {
                          name: newName,
                          group_fullname: newName,
                          last_message: dataMess.message,
                          last_message_id: dataMess.last_message_id
                        }

                        if (descGroup) {
                          groupObj.description = descGroup
                          paramsUpdateGroup.description = descGroup
                        }

                        chatDB.groups.update(rxaget(groupObj, 'group_id', '').toString(), paramsUpdateGroup).then(o => {
                          this.props.changeGroupFunc()
                        }).catch(e => { })
                        this.props.chooseGroupAction(groupObj)

                        if (netaRecentSearchGroups && netaRecentSearchGroups.groups && netaRecentSearchGroups.groups[groupObj.group_id]) {
                          let timeSearch = netaRecentSearchGroups.groups[groupObj.group_id].timeSearch
                          this.props.updateRecentSearchGroups(groupObj.group_id, groupObj, timeSearch)
                        }

                      }
                    })
                  } catch (error) { console.log("update_group name", error) }
                }
              })
            }

        }
      }
    } catch (error) { console.log("update_group name", error) }
  }

  openNewManager() {
    this.setState({ closeBtnClick: true })
  }

  closeNewManager() {
    this.setState({ closeBtnClick: false })
  }

  openAddAdminManager() {
    this.setState({ flagShowPopupAddAdmin: true })
  }

  closeAddAdminManager() {
    this.setState({ flagShowPopupAddAdmin: false })
  }

  openListManager() {
    this.setState({ flagShowListAdmin: true })
  }

  closeListManager() {
    this.setState({ flagShowListAdmin: false })
  }



  onClickStartCall(typeCall) {

    // this.props.updateRecentContactGroups(this.state.group.partner_id,Date.now())
    this.props.clickCall(typeCall, {
      group_id: rxaget(this.state, 'group.group_id', ''),
      type: rxaget(this.state, 'group.type', 0),
      occupants_uins: rxaget(this.state, 'group.occupants_uins', [])
    })
  }
  loadImgStatic(obj, name, url = global.rxu.config.cdn_endpoint) {

    if (obj.sender_avatar) {
      return global.rxu.config.get_static + obj.sender_avatar
    } else if (obj.avatar_url) {
      return global.rxu.config.get_static + obj.avatar_url
    } else if (obj.type === 3 && !obj.avatar_url) {
      const users = this.users
      if (obj && obj.occupants_uins && obj.occupants_uins.constructor === Array && obj.occupants_uins.length === 2 && obj.occupants_uins.indexOf(this.userid.toString()) !== -1) {
        const arruserid = obj.occupants_uins.filter(o => o !== this.userid.toString())
        if (arruserid && arruserid.constructor === Array && arruserid[0] && users[arruserid[0]] && users[arruserid[0]].profile_url) {
          return url + users[arruserid[0]].profile_url
        }
      } else {
        return './images/default/static/avadefault.svg'
      }
    } else {
      return './images/default/static/avadefault.svg'
    }
  }
  async loadMediaStatic() {
    const group = JSON.parse(JSON.stringify(this.state.group))
    const paging_page = this.state.paging_page
    const paging_size = this.state.paging_size
    const block_scroll = this.state.block_scroll
    let netaMedia = JSON.parse(JSON.stringify(rxaget(this.props.netaMedia, 'data.' + group.group_id, { images: {}, videos: {}, files: {} })))

    let checkMinMedia = { images: '', videos: '', files: '' }
    let checkMaxMedia = { images: '', videos: '', files: '' }
    let checkNewMaxMedia = { images: '', videos: '', files: '' }

    try {
      ['images', 'videos', 'files'].forEach(typeMedia => {
        Object.keys(netaMedia[typeMedia]).forEach(key => {
          if (netaMedia[typeMedia] && netaMedia[typeMedia][key] && netaMedia[typeMedia][key]['message_id'] && Number(checkNewMaxMedia[typeMedia]) < Number(netaMedia[typeMedia][key]['message_id'])) {
            checkNewMaxMedia[typeMedia] = netaMedia[typeMedia][key]['message_id']
          }
        })
      })
    } catch (e) { }

    let breakLoop = false
    let checkContinue = 0
    if (group && group.group_id && this.token) {
      if (!block_scroll) {
        for (let i = paging_page; i < 100; i++) {
          let pageoffset = i
          pageoffset = i
          const api_media_chat = global.rxu.config.get_media_chat
            + '?load_attachments=true&offset=' + pageoffset * paging_size + '&group_id='
            + group.group_id + '&media_type=2%2C%204%2C%2012&limit=' + paging_size
          this.controller[group.group_id] = new AbortController();
          let { signal } = this.controller[group.group_id];
          let res = await fetch(api_media_chat, {
            signal: signal, method: 'GET', headers: {
              Accept: 'application/json', 'TC-Token': this.token,
              Connection: 'Keep-Alive', 'Accept-Encoding': 'gzip'
            }, body: null
          }).catch(function (error) { });
          try {
            let json = await res.json()
            if (json && json.constructor === Array && json.length > 0) {
              if (this.state.group.group_id === group.group_id) {
                const arrMedia = json.filter((v, i, a) => a.findIndex(t => ((t.media_uid + t.message_id) === (v.media_uid + v.message_id))) === i).sort((a, b) => (a.msg_create_at > b.msg_create_at) ? 1 : ((b.msg_create_at > a.msg_create_at) ? -1 : 0))

                if (pageoffset === 0) {
                  try {
                    for (const media of arrMedia) {
                      let typeNameMedia = (media.media_type === 2) ? 'images' : (media.media_type === 4) ? 'videos' : (media.media_type === 12) ? 'files' : ''
                      if (typeNameMedia) {
                        if (checkMinMedia[typeNameMedia] === '') { checkMinMedia[typeNameMedia] = media.message_id }
                        if (checkMaxMedia[typeNameMedia] === '') { checkMaxMedia[typeNameMedia] = media.message_id }
                        if (Number(checkMinMedia[typeNameMedia]) > Number(media.message_id)) { checkMinMedia[typeNameMedia] = media.message_id }
                        if (Number(checkMaxMedia[typeNameMedia]) < Number(media.message_id)) { checkMaxMedia[typeNameMedia] = media.message_id }
                      }
                    }

                    for (let typeMedia of ['images', 'videos', 'files']) {
                      if (checkNewMaxMedia[typeMedia] && checkMaxMedia[typeMedia] && checkNewMaxMedia[typeMedia] !== checkMaxMedia[typeMedia]) {
                        Object.keys(netaMedia[typeMedia]).forEach(key => {
                          if (netaMedia[typeMedia] && netaMedia[typeMedia][key] && netaMedia[typeMedia][key]['message_id'] && Number(netaMedia[typeMedia][key]['message_id']) > Number(checkMinMedia[typeMedia])) {
                            delete netaMedia[typeMedia][key]
                          }
                        })
                        breakLoop = true
                      }
                    }

                    if (breakLoop) {
                      this.props.netaMediaDelMulti(group.group_id, checkMinMedia)
                    }
                  } catch (e3) { }
                }

                for (const media of arrMedia) {
                  let attachments = {}
                  try {
                    attachments = JSON.parse(rxaget(media, 'attachments', '').replace(/[\t\r\n]/g, ''))
                  } catch (e) {
                    if (typeof (rxaget(media, 'attachments', '')) === 'object') {
                      attachments = rxaget(media, 'attachments', '')
                    }
                  }
                  if (media.media_type === 2) {
                    if (attachments && attachments.images && attachments.images.constructor === Array && attachments.images.length > 0) {
                      for (const oimage of attachments.images) {
                        media.url = rxaget(oimage, 'url', '')
                        if (!netaMedia.images[media.url] && media.url) {
                          netaMedia.images[media.url] = { url: media.url, message_id: media.message_id, group_id: media.group_id, media_type: media.media_type, msg_create_at: media.msg_create_at }
                          checkContinue = checkContinue + 1
                        }
                      }
                    }
                  }

                  if (media.media_type === 4) {
                    if (attachments && attachments.video && attachments.video.constructor === Object) {
                      media.url = rxaget(attachments, 'video.url', '') || ''
                      media.thumbnail_url = rxaget(attachments, 'video.thumbnail_url', '') || ''
                      if (netaMedia.videos && !netaMedia.videos[media.url] && media.url) {
                        netaMedia.videos[media.url] = { url: media.url, thumbnail_url: media.thumbnail_url, message_id: media.message_id, group_id: media.group_id, media_type: media.media_type, msg_create_at: media.msg_create_at }
                        checkContinue = checkContinue + 1
                      }
                    }
                  }

                  if (media.media_type === 12) {
                    if (attachments && attachments.file && attachments.file.constructor === Object) {
                      media.url = rxaget(attachments, 'file.url', '') || ''
                      media.ext = rxaget(attachments, 'file.file_extension', '') || ''
                      media.file_name = rxaget(attachments, 'file.file_name', '') || ''
                      if (netaMedia.files && !netaMedia.files[media.url] && media.url) {
                        netaMedia.files[media.url] = { url: media.url, ext: media.ext, name: media.file_name, message_id: media.message_id, group_id: media.group_id, media_type: media.media_type, msg_create_at: media.msg_create_at }
                        checkContinue = checkContinue + 1
                      }
                    }
                  }
                }
                if (checkContinue === 0 || this.state.group.group_id !== group.group_id) { breakLoop = true }

                this.props.netaMediaAdd(group.group_id, netaMedia)

                if ((arrMedia && arrMedia.constructor === Array && arrMedia.length < paging_size) || this.state.group.group_id !== group.group_id) {
                  breakLoop = true
                }
                // console.log("++", i, paging_size, arrMedia.length, checkContinue, breakLoop)
              }
              else if (this.state.group.group_id !== group.group_id) {
                console.log("ASYCN CHANGE ID")
              }
            } else {
              this.setState({ paging_page: 0, arrData: [], block_scroll: false, loadingMedia: false })
              break
            }
          } catch (eJson) {
            this.setState({ paging_page: 0, arrData: [], block_scroll: false })
            break
          }

          await new Promise(resolve => setTimeout(resolve, 1000));
          if (this.state.group.group_id === group.group_id) {

            let arrDataTmp = []
            const type = this.state.tabactive || 'images'
            if (netaMedia && netaMedia[type]) {
              for (const key of Object.keys(netaMedia[type] || {})) {
                if (netaMedia[type][key]) { arrDataTmp.push(netaMedia[type][key]) }
              }
            }
            arrDataTmp = arrDataTmp.sort((a, b) => (a.msg_create_at > b.msg_create_at) ? -1 : ((b.msg_create_at > a.msg_create_at) ? 1 : 0))

            this.setState({ arrData: arrDataTmp })
          }

          if (breakLoop) {
            if (this.state.group.group_id === group.group_id) {
              // console.log("++", arrData, this.state.group.group_id, group.group_id)
              this.setState({ paging_page: i + 1, block_scroll: true, loadingMedia: false })
            }
            break
          }
        }
      }
    }
  }

  changeTabActive(type) {
    const group_id = rxaget(this.state.group, 'group_id', '')
    const netaMedia = rxaget(this.props.netaMedia, 'data.' + group_id, { images: {}, videos: {}, files: {} })
    let arrData = []
    if (netaMedia && netaMedia[type]) {
      for (const key of Object.keys(netaMedia[type] || {})) {
        if (netaMedia[type][key]) { arrData.push(netaMedia[type][key]) }
      }
    }
    arrData = arrData.sort((a, b) => (a.msg_create_at > b.msg_create_at) ? -1 : ((b.msg_create_at > a.msg_create_at) ? 1 : 0))
    this.setState({ tabactive: type, arrData: arrData })
  }

  showGallery({ index, type }) {
    this.setState({ checkgallery: true, galleryPosition: Number(index), type: type })
  }

  keyClickFunction(event) {
    if (event.keyCode === 27) {
      this.closeGallery()
    }
  }

  closeGallery() {
    this.setState({ checkgallery: false })
  }

  downloadFile(file_id, file_name) {
    const src = global.rxu.config.get_static + '/' + file_id
    try {
      if (!this.blockDownload) {
        this.blockDownload = true
        fetch(src)
          .then(resp => resp.blob())
          .then(blob => {
            const url = window.URL.createObjectURL(blob)
            const downloaBOBACU = document.createElement('a')
            downloaBOBACU.style.display = 'none'
            downloaBOBACU.href = url
            downloaBOBACU.download = file_name
            document.body.appendChild(downloaBOBACU)
            downloaBOBACU.click()
            window.URL.revokeObjectURL(url)
            this.blockDownload = false
          })
          .catch(() => {
            console.log('Error')
            this.blockDownload = false
          })
      } else {
        alert(translate('Downloading your file please wait ...'))
      }
    } catch (e) {
      this.blockDownload = false
    }
  }

  getStringsImages(arrData) {
    let galleryImages = ''
    arrData.forEach(element => {
      galleryImages += element.url.replace(/\s/g, '') + ','
    })
    return (
      galleryImages

    )
  }

  clearSearchBox() {
    const chatDiv = document.getElementById('addmember_searchBox')
    chatDiv.value = ''
  }

  func_getCharacName(name) {
    let arrName = name.split(' ');
    if (arrName.length === 1) {
      let _name = arrName[0][0] + arrName[0][1]
      return _name.toUpperCase()
    }
    else {
      let _name = (arrName[0][0] + arrName[arrName.length - 1][0])
      return _name.toUpperCase()
    }
  }

  loadGroupsTemp(group, users) {
    let occupants_uins = rxaget(group, 'occupants_uins', [])
    let admin_uins = rxaget(group, 'admin_uins', [])
    let owner_uin = {}
    let groupsTemp = []
    let arrAdminsTemp = []
    if (occupants_uins) {
      for (const useridkey of Object.keys(users)) {
        for (let i = 0; i < occupants_uins.length; i++) {
          if (String(occupants_uins[i]) === String(users[(useridkey)].id)) { //id user có rồi
            groupsTemp.push(users[(useridkey)])
          }
        }

        if (admin_uins && admin_uins.constructor === Array && admin_uins.length > 0 && admin_uins.indexOf(useridkey) !== -1) {
          if (useridkey.toString() === rxaget(group, 'owner_uin', '').toString()) {
            arrAdminsTemp.unshift(users[(useridkey)])
          } else {
            arrAdminsTemp.push(users[(useridkey)])
          }
        }
      }
      this.setState({
        groupsTemp: groupsTemp,
        arrAdminsTemp: arrAdminsTemp,
        chooseLeader_groupsTemp: groupsTemp,
        lg_chooseLeader_groupsTemp: groupsTemp,
      })
    }

  }

  uploadFileImages(fileList) {
    try {
      if (fileList.length && fileList[0]) {
        var file = fileList[0]
        let parts = (file.name || '').split('.');
        let ext = parts[parts.length - 1] || '';
        if (['png', 'jpg'].indexOf(ext.toLowerCase()) >= 0) {
          let fileSize = file.size
          let extFilename = 'png'

          let _URL = window.URL || window.webkitURL
          let img = new Image();
          let objectUrl = _URL.createObjectURL(file)

          let dataParams = {
            content_type: 'image/' + extFilename,
            name: 'netalo_' + Math.floor(Date.now()),
            public: true,
            size: fileSize
          }
          let header = { 'TC-Token': this.token, 'Content-Type': 'application/json; charset=UTF-8', 'Accept-Encoding': 'gzip', 'Connection': 'keep-alive' }
          let requestOptions = {
            method: 'POST', headers: header, body: JSON.stringify(dataParams), redirect: 'follow'
          };

          fetch(global.rxu.config.create_blob, requestOptions).then(res => res.json()).then((json) => {
            if (json && json.blod_object && json.blod_object.form_data) {
              let dataUpload = new FormData()
              let arrKeys = ['Content-Type', 'key', 'policy', 'x-amz-algorithm', 'x-amz-credential', 'x-amz-date', 'x-amz-meta-netachat', 'x-amz-signature']
              for (let key of arrKeys) {
                if (json.blod_object.form_data[key]) {
                  dataUpload.append(key, json.blod_object.form_data[key])
                }
              }
              dataUpload.append('file', file, file.name)
              dataUpload.append('success_action_status', 201)

              fetch(json.blod_object.params, { method: 'POST', body: dataUpload }).then(resBlob => resBlob.text()).then(result => {
                if (result.indexOf('Key') !== -1) {
                  let patt = '<Key.*?>(.*?)<\\/Key>';
                  let strresult = result.match(patt);
                  if (strresult && strresult.constructor === Array && strresult.length > 1) {
                    let key = strresult[1]
                    if (key) {
                      let optComplete = {
                        method: 'PUT',
                        headers: header,
                        body: JSON.stringify({
                          content_type: json.content_type, id: json.id, name: json.name, size: json.size, uid: json.uid
                        })
                      };

                      fetch(global.rxu.config.get_blobs + '/' + json.id + '/complete.json', optComplete)
                        .then(response => {
                          if (response.status === 200) {
                            try {
                              img.onload = () => {
                                _URL.revokeObjectURL(objectUrl)
                                const arrUsers = this.users
                                const user = rxaget(this.props, 'netaauth.user', {})
                                const objUser = arrUsers[user.id.toString()]
                                let msg = {
                                  group_id: Number(this.state.group.group_id),
                                  avatar_url: key,
                                }
                                if (msg && msg.group_id) {
                                  if (rxio.connected) {
                                    rxio.socket.emit("update_group", msg, (data) => {
                                      if (data && data.result === 0) {
                                        let msg = {
                                          group_id: Number(this.state.group.group_id),
                                          type: 6,
                                          version: 1,
                                          nonce: (Math.floor(Date.now()) * 1000).toString(),
                                          sender_name: rxaget(objUser, 'full_name', ''),
                                          attachments: JSON.stringify({
                                            updated_group_avatar: key,
                                            mediaType: 0, type: "update_group"
                                          }).replace(/"/g, '\\"'),
                                          "is_encrypted": false, "mentioned_all": false
                                        }
                                        rxio.socket.emit('create_message', msg, (dataMess) => {
                                          if (dataMess) {
                                            let groupObj = JSON.parse(JSON.stringify(this.state.group))
                                            groupObj.avatar_url = key
                                            groupObj.last_message = dataMess.message
                                            groupObj.last_message_id = dataMess.last_message_id
                                            this.props.changeStatusLoadMess()
                                            this.props.chooseGroupAction(groupObj)
                                            this.handleMessage(dataMess.message, true, 'footer')

                                            chatDB.groups.get({ group_id: rxaget(this.state.group, 'group_id', '').toString() }).then(groupObj => {
                                              if (groupObj && groupObj.group_id) {
                                                let paramsUpdateGroup = {
                                                  avatar_url: key,
                                                  last_message: dataMess.message,
                                                  last_message_id: dataMess.last_message_id
                                                }
                                                chatDB.groups.update(rxaget(groupObj, 'group_id', '').toString(), paramsUpdateGroup).then(o => {
                                                  this.props.changeGroupFunc()
                                                }).catch(e => { })
                                              }
                                            }).catch(e => { })



                                          }
                                        })
                                      }
                                    })
                                  }
                                }
                              }
                              img.src = objectUrl
                            } catch (e) { }
                          }
                        }).catch(errorPut => console.log('error', errorPut));
                    }
                  }
                }
              })
            }
          }).catch(error => console.log('create_blob error', error))
        } else alert(translate('The image file format is not suitable. Please select the image file as .jpg or .png'))
      }
    } catch (error) { console.log('upload error', error) }
  }

  disableDrop = event => {
    event.preventDefault();
  }

  createLinkGroup(callback) {
    let groupObj = JSON.parse(JSON.stringify(this.state.group))
    if (groupObj) {
      if (!groupObj.link_group) {
        rxio.createLink(groupObj.group_id, (data) => {
          if (data && data.link) {
            groupObj.link_group = data.link

            callback(groupObj.link_group)
            this.props.netaGroupsUpdate(Number(groupObj.group_id), groupObj, true)
          }
        })
      } else {
        callback(groupObj.link_group)
      }
    }

    this.setState({ flagCopyLink: true })
  }

  onClickShareLinkGroup() {
    this.createLinkGroup((link) => {
      this.copyTextToClipboard(link)
    })

    this.setState({ flagCopyLink: true })
  }

  onToggleOffLinkGroup() {
    this.setState({ flagCopyLink: false })
  }

  onClickQRLinkGroup() {
    this.createLinkGroup((link) => {
      this.props.clickPopup('create_qr', { data: { link: link, group: this.state.group } })
    })
  }

  copyTextToClipboard(text) {
    let textArea = document.createElement('textarea')
    textArea.style.position = 'fixed'
    textArea.style.top = 0
    textArea.style.left = 0
    textArea.style.width = '2px'
    textArea.style.height = '2px'
    textArea.style.padding = 0
    textArea.style.border = 'none'
    textArea.style.outline = 'none'
    textArea.style.boxShadow = 'none'
    textArea.style.background = 'transparent'
    textArea.value = text.replace(/[\t\r\n]/g, '')
    document.body.appendChild(textArea)
    textArea.focus()
    textArea.select()
    try {
      document.execCommand('copy')
    } catch (err) {
      console.log('Oops, unable to copy')
    }
    document.body.removeChild(textArea)
  }

  getNumMemberOnl(group) {
    let userid = this.userid
    let countMemberOnl = getNumMemberOnl(group, userid)
    return countMemberOnl
  }

  uniqArray(a) {
    return Array.from(new Set(a));
  }

  checkMemberStatus(ele) {
    let userid = this.userid
    let status_list = this.state.group.status_list
    if (ele.id.toString() === userid.toString()) {
      return 1
    } else {
      for (let i = 0; i < status_list.length; i++) {
        if (status_list[i].uin === ele.id.toString()) {
          return status_list[i].online_status
        }
      }
    }
    return 2
  }

  clickInfoUser(userid) {
    if (userid) {
      this.setState({
        infoUserScreen: true,
        infoUserId: Number(userid)
      })
    }
  }

  closePopupInfoUser() {
    this.setState({
      infoUserScreen: false,
      infoUserId: 0
    })
  }

  rowMember({ data, index, style }) {
    let group = this.state.group
    let occupants_uins = rxaget(group, 'occupants_uins', [])
    let uin = occupants_uins[index]
    let userMember = worker.users[uin] || {}

    let flagLeader = false
    if (this.isLeader(userMember.id)) {
      flagLeader = true
    }

    let userName = this.getNameUser(userMember)
    return <div style={style} key={index}>
      {(userMember) && <div className={'newManager_zgroupitem-contact clearfix'} >
        <div className='newManager_avatar' onClick={() => this.clickInfoUser(uin)}>
          {(userMember.profile_url) && <img src={global.rxu.config.cdn_endpoint + userMember.profile_url} alt='' className='ava-group images-static'
            onError={(e) => { e.target.onerror = null; e.target.src = `./images/default/static/avadefault.svg` }} />}
          {!userMember.profile_url && <span className='ava-span' style={{ background: `${changeColorAva(uin)}` }}>{textAva(rxChangeSlug(this.getNameUser(userMember)))}</span>}
        </div>

        <div className={'zgroup_maininfo-contact ' + (uin !== this.userid && this.isLeader(this.userid) ? "edit" : '')}>
          {(userName.length > 24) && <div className='name_userinfo_row' username-tooltip-position='right' username-tooltip={userName} onClick={() => this.clickInfoUser(uin)}>
            <div className='info_nameuser_row'>{subString(userName, 24)}</div>
          </div>}
          {(userName.length <= 24) && <div className='name_userinfo_row' onClick={() => this.clickInfoUser(uin)}>
            <div className='info_nameuser_row'>{userName}</div>
          </div>}

          <div className='manager_role_row'>
            {flagLeader && <div className='manager_role_name'>
              {(group && uin.toString() === group.owner_uin.toString()) && translate('Owner')}
              {(group && uin.toString() !== group.owner_uin.toString() && group.admin_uins.indexOf(uin.toString()) !== -1) && translate('Admin')}
            </div>}

            <div className='info_new_statususer_row'>{(uin && uin.toString() === this.userid.toString()) ? <span className='status-online'>{translate('Online')}</span> : <OnOffUser userId={uin} className='status-online' />}</div>

          </div>

          {(group && this.userid.toString() === group.owner_uin.toString() && this.userid.toString() !== uin.toString()) && <div className='remove_member_new' onClick={() => this.removeMember(userMember)}>
            {translate('Remove')}
          </div>}
          {(group && this.userid.toString() !== group.owner_uin.toString() && uin.toString() !== group.owner_uin.toString() && this.userid.toString() !== uin.toString() && group.admin_uins.indexOf(this.userid.toString()) !== -1 && group.admin_uins.indexOf(uin.toString()) === -1) && <div className='remove_member_new' onClick={() => this.removeMember(userMember)}>
            {translate('Remove')}
          </div>}

          {/* {(!flagLeader && this.isLeader(this.userid)) && <div className='remove_member_new' onClick={() => this.removeMember(userMember)} >
            {translate('Remove')}
          </div>} */}
        </div>
        <div className='group_divider' ></div>
      </div>}

    </div>
  }

  rowAdmin({ data, index, style }) {
    let group = this.state.group
    let admin_uins = this.state.arrAdminsTemp
    let uin = rxaget(admin_uins, index + '.uid', '').toString()

    let userMember = worker.users[uin] || {}

    let flagLeader = false
    if (this.isLeader(userMember.id)) {
      flagLeader = true
    }

    let userName = this.getNameUser(userMember)
    return <div style={style} key={index}>
      {(userMember) && <div className={'newManager_zgroupitem-contact clearfix'} >
        <div className='newManager_avatar' onClick={() => this.clickInfoUser(uin)}>
          {(userMember.profile_url) && <img src={global.rxu.config.cdn_endpoint + userMember.profile_url} alt='' className='ava-group images-static'
            onError={(e) => { e.target.onerror = null; e.target.src = `./images/default/static/avadefault.svg` }} />}
          {!userMember.profile_url && <span className='ava-span' style={{ background: `${changeColorAva(uin)}` }}>{textAva(rxChangeSlug(this.getNameUser(userMember)))}</span>}
        </div>

        <div className={'zgroup_maininfo-contact ' + (uin !== this.userid && this.isLeader(this.userid) ? "edit" : '')}>
          {(userName.length > 24) && <div className='name_userinfo_row' username-tooltip-position='right' username-tooltip={userName} onClick={() => this.clickInfoUser(uin)}>
            <div className='info_adminuser_row'>{subString(userName, 24)}</div>
          </div>}
          {(userName.length <= 24) && <div className='name_userinfo_row' onClick={() => this.clickInfoUser(uin)}>
            <div className='info_adminuser_row'>{userName}</div>
          </div>}

          {flagLeader && <div className='newManager_leader'>
            {(group && uin.toString() === group.owner_uin.toString()) && translate('Owner')}
            {/* {(group && uin.toString() !== group.owner_uin.toString() && group.admin_uins.indexOf(uin.toString()) !== -1 ) && translate('Admin')} */}
          </div>}
          {(group && this.userid.toString() === group.owner_uin.toString() && uin.toString() !== group.owner_uin.toString()) && <div className='remove_admin_btn' onClick={() => this.removeAdmin(userMember)} >
            {translate('Remove')}
          </div>}
        </div>
        <div className='group_divider' ></div>
      </div>}

    </div>
  }

  getUserStatus_txt() {
    let user_status_txt = this.props.langValue === 'en' ? rxaget(this.state, 'group.userStatus.status_message_en', '') : rxaget(this.state, 'group.userStatus.status_message', '')
    return user_status_txt
  }

  checkPollListState(pollListState) {
    // let pollListState = rxaget(this.props, 'rxPollListState.status', false)
    if (pollListState) {
      this.props.updateListPollState(false)
      this.setState({ flagPollList: true })
    }
  }

  showListPoll(value) {
    this.setState({ flagPollList: value })
  }

  render() {
    const group = this.state.group

    const tabactive = this.state.tabactive
    const arrData = this.state.arrData
    const galleryImages = arrData && this.getStringsImages(arrData)
    let occupants_uins = rxaget(this.state.group, 'occupants_uins', [])
    let itemCount = occupants_uins.length
    let groupsTemp = [...this.state.groupsTemp]

    let arrAdmins = rxaget(this.state.group, 'admin_uins', [])
    let chooseLeader_groupsTemp = [...this.state.chooseLeader_groupsTemp]//.filter(u => arrAdmins.indexOf(rxaget(u, 'id', '').toString()) === -1)    
    let chooseLeaderItemCount = chooseLeader_groupsTemp.length
    const ChooseLeaderRow = ({ index, style }) => {
      let userName = checkNameUser(chooseLeader_groupsTemp[index])
      return <div style={style}>
        {this.userid !== chooseLeader_groupsTemp[index].id && <div className={(chooseLeader_groupsTemp[index].group_id === this.state.group_id) ? 'newManager_zgroupitem-contact active clearfix' : 'newManager_zgroupitem-contact clearfix'} key={index}  >
          <div className='newManager_avatar'>
            {(chooseLeader_groupsTemp[index].profile_url) && <img src={global.rxu.config.cdn_endpoint + chooseLeader_groupsTemp[index].profile_url} alt='' className='ava-group images-static'
              onError={(e) => { e.target.onerror = null; e.target.src = `./images/default/static/avadefault.svg` }} />
            }
            {!chooseLeader_groupsTemp[index].profile_url &&
              <span className='ava-span' style={{ background: `${changeColorAva(chooseLeader_groupsTemp[index]['group_id'])}` }}>{textAva(rxChangeSlug(checkNameContact(chooseLeader_groupsTemp[index])))}</span>
            }

          </div>
          <div className='zgroup_maininfo-contact' onClick={e => this.chooseLeader(chooseLeader_groupsTemp[index])}>
            {(userName.length > 20) && <div className='newgroup_userinfo_place' username-tooltip-position='right' username-tooltip={userName}> {subString(userName, 20)}  </div>}
            {(userName.length <= 20) && <div className='newgroup_userinfo_place'> {userName} </div>}
            <div className='newManager_checked' >
              <label className='container101'>
                <input className='checkmark_leader_account' type='radio' name="newManager_radio" defaultChecked={this.state.leaderMemberChecked === rxaget(chooseLeader_groupsTemp, index + '.id', 0)} />
                <span className='checkmark_choose_leader_account' onClick={e => this.chooseLeader(chooseLeader_groupsTemp[index])}></span>

              </label>
            </div>
          </div>
          <div className='group_divider' ></div>
        </div>}

      </div>
    };

    let arrAdminMemberChecked = this.state.arrAdminMemberChecked.map(u => u.id)

    const ChooseAdminRow = ({ index, style }) => {
      let userName = checkNameUser(chooseLeader_groupsTemp[index])
      return <div style={style}>
        {this.userid !== chooseLeader_groupsTemp[index].id && <div className={(chooseLeader_groupsTemp[index].group_id === this.state.group_id) ? 'newManager_zgroupitem-contact active clearfix' : 'newManager_zgroupitem-contact clearfix'} key={index}  >
          <div className='newManager_avatar'>
            {(chooseLeader_groupsTemp[index].profile_url) && <img src={global.rxu.config.cdn_endpoint + chooseLeader_groupsTemp[index].profile_url} alt='' className='ava-group images-static'
              onError={(e) => { e.target.onerror = null; e.target.src = `./images/default/static/avadefault.svg` }} />
            }
            {!chooseLeader_groupsTemp[index].profile_url &&
              <span className='ava-span' style={{ background: `${changeColorAva(chooseLeader_groupsTemp[index]['group_id'])}` }}>{textAva(rxChangeSlug(checkNameContact(chooseLeader_groupsTemp[index])))}</span>
            }

          </div>
          <div className='zgroup_maininfo-contact' >
            {(userName.length > 20) && <div className='newgroup_userinfo_place' username-tooltip-position='right' username-tooltip={userName}> {subString(userName, 20)}  </div>}
            {(userName.length <= 20) && <div className='newgroup_userinfo_place'> {userName} </div>}
            <div className='newManager_checked' >
              <label className='container101'>
                <input className='checkmark_leader_account' type='checkbox' name="newManager_radio" onClick={e => this.chooseAdmin(e, chooseLeader_groupsTemp[index])} defaultChecked={arrAdminMemberChecked.indexOf(rxaget(chooseLeader_groupsTemp, index + '.id', 0)) !== -1} />
                <span className='checkmark_choose_leader_account'></span>
              </label>
            </div>
          </div>
          <div className='group_divider' ></div>
        </div>}

      </div>
    };

    const getItemSize = index => {
      if (chooseLeader_groupsTemp && chooseLeader_groupsTemp[index] && chooseLeader_groupsTemp[index].id && this.userid === chooseLeader_groupsTemp[index].id) {
        return 0
      }
      return 60

    }
    let heightLeaderContactList = (60 * Number(chooseLeaderItemCount) + 20)
    if (heightLeaderContactList > 600) {
      heightLeaderContactList = 600
    }
    const ChooseLeaderContactList = () => (
      <VariableSizeList
        className="selectManager_contactlist"
        height={heightLeaderContactList}
        itemCount={chooseLeaderItemCount}
        itemSize={getItemSize}
        width={300}
      >
        {ChooseLeaderRow}
      </VariableSizeList>
    );

    let heightadminsList = (60 * Number(arrAdmins.length) + 20)
    if (heightadminsList > 600) {
      heightadminsList = 600
    }
    const ListAdminsComponent = () => (
      <VariableSizeList
        className="selectManager_adminlist"
        height={heightadminsList}
        itemCount={arrAdmins.length}
        itemSize={getItemSize}
        width={300}
      >
        {this.rowAdmin}
      </VariableSizeList>
    );

    function UserAvatar({ avatarurl, uid, groupid, groupfullname, grouptype }) {
      let users = worker.users
      let profileurl = (users && users[uid] && users[uid]['profile_url']) ? users[uid]['profile_url'] : ''
      let name = (group && group.group_fullname) ? group.group_fullname : (group && group.name) ? group.name : (users && users[uid]) ? (users[uid]['full_name']) ? users[uid]['full_name'] : (users[uid]['phone']) ? users[uid]['phone'] : translate('Stranger') : translate('Stranger')
      return (
        <div className='edit_img_user_group'>
          {(avatarurl) && <img src={global.rxu.config.get_static + avatarurl} alt='avatar_url' className='account-ava-group images-static' onError={(e) => { e.target.onerror = null; e.target.src = './images/default/static/avadefault.svg' }} />}
          {(!avatarurl && profileurl && (grouptype == 3)) && <img src={`${global.rxu.config.cdn_endpoint}` + profileurl} alt='profile_url' data-id={'userava' + uid} className='account-ava-group images-static' onError={(e) => { e.target.onerror = null; e.target.src = './images/default/static/avadefault.svg' }} />}
          {!(avatarurl) && <span className='account-ava-span' style={{ background: (grouptype == 3) ? `${changeColorAva(uid)}` : `${changeColorAva(groupid)}` }}>
            {(grouptype == 3) ? textAva(rxChangeSlug(name, true)) : textAva(rxChangeSlug(name, true))}
          </span>


          }
        </div>
      )
    }

    const MemoizedUserAvatar = UserAvatar//React.memo(UserAvatar);

    return (
      <Fragment>
        {this.state.infoUserScreen && <RxInfoUser closePopupInfoUser={() => this.closePopupInfoUser()} infoUserId={this.state.infoUserId} />}
        <div className='account_info_tab_right' >
          <div className='account_info_tab_right-user'>
            <div className='account_info_tab_right-user-header'>

              <MemoizedUserAvatar
                avatarurl={zget(this.state.group, 'avatar_url', '')}
                uid={zget(this.state.group, 'partner_id', '')}
                groupid={zget(this.state.group, 'group_id', '')}
                groupfullname={zget(this.state.group, 'group_fullname', '')}
                grouptype={zget(this.state.group, 'type', 0)}
              />
              <div className='account_info_tab_right-btn-edit'>
                {/*((this.isLeader(this.userid) && rxaget(group, 'type', 0) !== 3) || rxaget(group, 'type', 0) === 3) && !this.state.isBlocked &&
                  <span className='account_info_tab_right-txt-edit' onClick={e => this.editAccountInfo()}>{translate('Edit')}</span>
                */}
                {
                  this.isLeader(this.userid) && rxaget(group, 'type', 0) !== 3 &&
                  <span className='account_info_tab_right-txt-edit' onClick={e => this.editAccountInfo()}>{translate('Edit')}</span>
                }

              </div>
            </div>
            <span className='account_info_tab_right-user-name'>
              {subString((zget(group, 'name', '') || zget(group, 'group_fullname', '')), 50)}

            </span>

            {/*{(rxaget(group, 'type', 0) === 3)
              && this.state.group
              && (this.state.group.partner_id || this.state.group.occupants_uins[0])
              && this.state.usersStatus[Number(this.state.group.partner_id || this.state.group.occupants_uins[0])]
              && (this.state.usersStatus[Number(this.state.group.partner_id || this.state.group.occupants_uins[0])].online_status === 1
                ? <span className='account_info_tab_right-status'>Online</span>
                : this.state.usersStatus[Number(this.state.group.partner_id
                  || this.state.group.occupants_uins[0])].last_seen_at > 0
                  ? <span className='account_info_tab_right-status'>
                    {translate('Last seen ')}
                    {autoConvertTime(this.state.usersStatus[Number(this.state.group.partner_id || this.state.group.occupants_uins[0])].last_seen_at)}
                  </span>
                  : <span className='account_info_tab_right-status'>Offline</span>)
            }*/}

            {/*{(rxaget(group, 'type', 0) !== 3)
              && <span className='account_info_tab_right-status'>
                {rxaget(group, 'occupants_uins', []).length}
                {translate(' member')}
                {this.state.countMemberOnl > 0 ? (', ' + this.state.countMemberOnl + ' Online') : ''}
              </span>
            }*/}

            {(zget(group, 'type', 0) === 3) && <span className='account_info_tab_right-status'>
              {/* <OnOffUser userId={rxaget(group, 'partner_id', '')} /> */}
              {this.getUserStatus_txt().length === 0 && <OnOffUser userId={rxaget(group, 'partner_id', '')} />}
              {this.getUserStatus_txt().length > 0 && this.getUserStatus_txt()}
            </span>}

            {(zget(group, 'type', 0) !== 3) && <span className='account_info_tab_right-status'>
              {(group.occupants_uins_origin) ? group.occupants_uins_origin.length : rxaget(group, 'occupants_uins', []).length} {translate(' member')} <OnOffGroup groupId={rxaget(group, 'group_id', '')} arrUsers={rxaget(group, 'occupants_uins', '')} />
            </span>}

            {(zget(group, 'type', 0) === 4) && <span className='account_info_tab_right-desc'>
              {zget(group, 'description', '')}
            </span>}


            <div className='account_info_tab_right-list-member' onClick={e => this.dropDownListMemberClick()}>
              <div className={((rxaget(group, 'type', 0) !== 3 && rxaget(group, 'type', 0) !== 4) || (rxaget(group, 'type', 0) === 4 && this.isLeader(this.userid))) ? 'account_info_tab_right-list-member-body' : 'className_hiden'}>
                <div className='account_info_tab_right-list-member-title'>
                  {translate('Group members')}
                </div>
                <div className='account_info_tab_right-list-member-icon'>
                  <i className={this.state.displayGroupList === true ? 'editGroup_arrow_right' : 'arrow down'}></i>
                </div>
              </div>
            </div>
          </div>

          {/* HERE }
          {(rxaget(group, 'type', 0) === 3) && <div className='ztab-more-accountinfo'>
            {(this.user && this.user.phone.indexOf('ipa\\') !== -1) && <div className='ztab-more-accinfo_phone'>
              <span className='ztab-more-info_phone-txt'>{translate('Customer Id')}</span>
              <span className='ztab-more-info_phone_number'>{zget(this.users, [this.state.group.partner_id], {}).customerid || ''}</span>
            </div>}
            {<div className='ztab-more-accinfo_act'>
              {!this.state.isBlocked && <img className='icon32 icon-act filter_img_class' alt='' src={changeColorSVG('./images/default/icons/callright.svg')} onClick={(e) => this.onClickStartCall('voicecall')} />}
              {!this.state.isBlocked && <img className='videocall-icon icon-act filter_img_class' alt='' src={changeColorSVG('./images/default/icons/videocall.svg')} onClick={(e) => this.onClickStartCall('videocall')} />}
            </div>}
          </div>}

          {/* Danh sach nhom */}
          {/*(rxaget(group, 'type', 0) === 3) || (this.state.displayGroupList === true)*/}
          {/*((rxaget(group, 'type', 0) !== 3 && rxaget(group, 'type', 0) !== 4) || (rxaget(group, 'type', 0) === 4 && this.isLeader(this.userid)))*/}
          <div className={(((rxaget(group, 'type', 0) !== 3 && rxaget(group, 'type', 0) !== 4) || (rxaget(group, 'type', 0) === 4 && this.isLeader(this.userid))) && (this.state.displayGroupList === true)) ? 'newManager_contactlist' : 'newManager_contactlist_hiden'} id='zgroup_list' onScroll={this.scrollGroupChat}>
            {/*<ContactList/>*/}
            <SearchUserName theme={rxaget(this.props, "themeBackgroudValue")} onChange={(value) => { this.onChangeSearchMember(value) }} />
            <FixedSizeList
              className="newManager_contactlist"
              height={200}
              itemCount={itemCount}
              itemSize={60}
              width={300}
              itemData={{ searchName: this.state.searchName }}
            >
              {this.rowMember}
            </FixedSizeList>


            {/*{this.state.groupsTemp.map((ele, index) =>
              <div className={(ele.group_id === this.state.group_id) ? 'newManager_zgroupitem-contact active clearfix' : 'newManager_zgroupitem-contact clearfix'} key={index}  >
                <div className='newManager_avatar'>
                  {(ele.profile_url) && <img src={global.rxu.config.cdn_endpoint + ele.profile_url} alt='' className='ava-group images-static'
                    onError={(e) => { e.target.onerror = null; e.target.src = `./images/default/static/avadefault.svg` }} />}
                  {!ele.profile_url && <span className='ava-span' style={{ background: `linear-gradient(120deg, ${stringToColour('FFF' + textAva(checkNameContact(ele)))}, #FFFFFF)` }}>{textAva(rxChangeSlug(checkNameUser(ele)))}</span>}
                </div>

                <div className={'zgroup_maininfo-contact ' + (ele.id !== this.userid && this.isLeader(this.userid) ? "edit" : '')}>
                  <div className='newManager_userinfo_place'> {subString(checkNameUser(ele, this.userid, this.props.netaauth), 20)} </div>
                  {!this.isLeader(ele.id) && <div className='remove_member'
                    onClick={() => this.removeMember(ele)} >{translate('Remove')}</div>}
                  {<div className={this.isLeader(ele.id) ? 'newManager_leader' : 'newManager_leader_hiden'}>{translate('Leader')}</div>}
                  <div className={'newManager_user_online ' +
                    (this.state.usersStatus[Number(ele.id)] && this.state.usersStatus[Number(ele.id)].online_status === 1 ? "online" : "")}>
                    {this.state.usersStatus[Number(ele.id)] && (this.state.usersStatus[Number(ele.id)].online_status === 1 ? "Online"
                      : this.state.usersStatus[Number(ele.id)].last_seen_at > 0 ?
                        (translate('Last seen ') + autoConvertTime(this.state.usersStatus[Number(ele.id)].last_seen_at)) :
                        "Offline")}
                  </div>
                </div>
                <div className='group_divider' ></div>
              </div>
            )
            }*/}
          </div>

          {(this.state.partnerProfile.type !== 0) && <div className={(rxaget(group, 'type', 0) === 3) ? 'newManager_profileinfo' : 'newManager_contactlist_hiden'}>
            {(this.state.partnerProfile && this.state.partnerProfile.username !== '' && this.state.partnerProfile.type === 1) && <div>
              {this.arrDefaultStaff.map((ele, index) => <div className="newManager_zgroupitem-profile clearfix" key={index}>
                <div className="zgroupitem_profile-title">
                  {translate(ele.name)}
                </div>
                <div className="zgroupitem_profile-info">
                  {this.state.partnerProfile[ele.key]}
                </div>
              </div>)}
            </div>}
            {/* {(this.state.partnerProfile && this.state.partnerProfile.username !== '' && this.state.partnerProfile.type === 2) && <div>
              {this.arrDefaultCustomer.map((ele, index) => <div className="newManager_zgroupitem-profile clearfix" key={index}>
                <div className="zgroupitem_profile-title">
                  {translate(ele.name)}
                </div>
                <div className="zgroupitem_profile-info">
                  {this.state.partnerProfile[ele.key]}
                </div>
              </div>)}
            </div>} */}
          </div>}


          <div className='ztab-add-member'>
            <div className='zact-add_account_info'>
              <span className=
                {
                  ((rxaget(group, 'type', 0) !== 3 && rxaget(group, 'type', 0) !== 4) ||
                    (rxaget(group, 'type', 0) === 4) && this.isLeader(this.userid)) ?
                    'zact-add-member' :
                    'zact-add-member_hiden'}
                onClick={e => this.onClickAddMember()}
              >
                {translate('Add member')}
              </span>

              <span className={rxaget(group, 'type', 0) === 3 ? 'zact-block-contact' : 'zact-block-contact_hiden'} onClick={e => { this.setState({ displayAskBlock: true }) }}  >
                {(!this.state.isBlocked || this.state.isBlocked === 2) ? translate('Block contact') : translate('Unblock contact')}
              </span>
            </div>
          </div>


          {(rxaget(group, 'type', 0) !== 3 && this.isLeader(this.userid)) && <div className={(this.state.isBlocked === 2) ? 'ztab-add-member_hiden' : 'ztab-add-member'} >
            <div className='zact-add_account_info'>
              <span className={rxaget(group, 'type', 0) !== 3 ? 'zact-add-member tooltip' : 'zact-add-member_hiden'}
                onClick={e => this.onClickShareLinkGroup()} onMouseOut={(e) => this.onToggleOffLinkGroup()}
              >
                {translate('Link Sharing Group')}
                <span className="tooltiptext">{(!this.state.flagCopyLink) ? translate('Copy Link Group') : translate('Copied') + '!'}</span>
              </span>
            </div>
          </div>}

          {(rxaget(group, 'type', 0) !== 3 && this.isLeader(this.userid)) && <div className={(this.state.isBlocked === 2) ? 'ztab-add-member_hiden' : 'ztab-add-member'} >
            <div className='zact-add_account_info'>
              <span className={rxaget(group, 'type', 0) !== 3 ? 'zact-add-member' : 'zact-add-member_hiden'}
                onClick={e => this.onClickQRLinkGroup()}
              >
                {translate('Group QR code')}
              </span>
            </div>
          </div>}

          {(rxaget(group, 'type', 0) !== 3) && <div className={(this.state.isBlocked === 2) ? 'ztab-add-member_hiden' : 'ztab-add-member'} >
            <div className='zact-add_account_info'>
              <span className={rxaget(group, 'type', 0) !== 3 ? 'zact-add-member' : 'zact-add-member_hiden'}
                onClick={e => this.showListPoll(true)}
              >
                {translate('Poll')}
              </span>
            </div>
          </div>}

          <div className={this.state.notificationStatus === true ? 'ztab-more-act' : 'ztab-more-act_hiden'}>
            <div className='zact-add_account_info_noti'>
              <span className='zact-add-member'>
                {translate('Allows notifications')}
              </span>
              <div className='account_info_noti_mode'>
                <label className='switch'>
                  <input className='pushToggles' type='checkbox' checked={!this.state.disableNoti}
                    onChange={e => this.onChangeNotiGroup()} />
                  <span className='slider round'></span>
                </label>
              </div>
            </div>
          </div>

          {/*<div className={this.state.notificationStatus === true ? 'ztab-more-act' : 'ztab-more-act_hiden'}>
              <div className='zact-add_account_info_noti'>
                <span className='zact-add-member'>
                  {translate('Notification sound')}
                </span>
                <div className='account_info_noti_mode'>
                  <label className='switch'>
                    <input className='pushToggles' type='checkbox' checked={!this.state.disableNotiSound}
                      onChange={e => this.onChangeNotiSoundGroup()} />
                    <span className='slider round'></span>
                  </label>
                </div>
              </div>
            </div>*/}
          <div className='ztab-more-act'>
            <div className={(rxaget(group, 'type', 0) !== 3 && rxaget(group, 'type', 0) !== 4) ? 'zact' : 'zact_hiden'}>
              <span className={rxaget(group, 'type', 0) !== 3 ? 'zact-leave-group' : 'zact-leave-group_hiden'}
                onClick={e => this.leaveGroupBtnClick()}>
                {translate('Leave group')}
              </span>
            </div>
            <div className={(rxaget(group, 'type', 0) === 4 && !this.isLeader(this.userid)) ? 'zact' : 'zact_hiden'}>
              <span className={rxaget(group, 'type', 0) !== 3 ? 'zact-leave-group' : 'zact-leave-group_hiden'}
                onClick={e => this.leaveGroup()}>
                {translate('Unfollow')}
              </span>
            </div>
          </div>
          <div className='ztab-more-document'>
            <div className='zdocument-header'>
              <span className={(tabactive === 'images') ? 'zdocument-header-txt zdocument-header-txt-active' : 'zdocument-header-txt'} onClick={e => this.changeTabActive('images')}>{translate('Image')}</span>
              <span className={(tabactive === 'videos') ? 'zdocument-header-txt zdocument-header-txt-active' : 'zdocument-header-txt'} onClick={e => this.changeTabActive('videos')}>Video</span>
              <span className={(tabactive === 'files') ? 'zdocument-header-txt zdocument-header-txt-active' : 'zdocument-header-txt'} onClick={e => this.changeTabActive('files')}>{translate('Document')}</span>
            </div>
            <div className='zdocument-list'>
              {(arrData && arrData.length > 0) && <>
                {arrData.map((ele, index) => (
                  <div key={ele.media_uid + ele.url} className='zdocument-item'>
                    {(tabactive === 'images') && <img src={global.rxu.config.get_static + ele.url} alt='' className='zdoc-item' onClick={e => this.showGallery({ index, type: 'img' })} />}
                    {(tabactive === 'videos') && <div className='zvideo-list' onClick={e => this.showGallery({ index, type: 'video' })}>
                      {(ele.thumbnail_url && ele.thumbnail_url !== '') && <img src={global.rxu.config.get_static + ele.thumbnail_url} alt='' className='zvideo-item' onClick={e => this.showGallery({ index, type: 'video' })} />}
                      <div className='zvideo-item-play'><img src={changeColorSVG('./images/default/static/icon-media-play-white.svg')} alt='icon-media-play-white' /></div>
                    </div>}
                    {(tabactive === 'files') && <div className='zdoc-list' title={ele.name || ''}>
                      <div className='zicon-doc'>
                        <span className='icon-doc' onClick={e => this.downloadFile(ele.url, rxaget(ele, 'name', '') + '.' + rxaget(ele, 'ext', ''))} />
                      </div>
                      <div className='zicon-name' title={ele.name || ''}>
                        <span className='icon-doc-name'>{(ele.name) ? ele.name.substring(0, (6)) + '...' : ''}</span>
                      </div>
                    </div>}
                  </div>))}
              </>}

              <div className="loading" style={{ display: this.state.loadingMedia ? 'flex' : 'none' }}><div className="dot-flashing"></div></div>
            </div>
            {this.state.checkgallery && RxImageGallery &&
              <RxImageGallery images={galleryImages} closeShowGallery={() => this.closeGallery()} position={this.state.galleryPosition} type={this.state.type} />
            }
          </div>
          {this.state.displayAskBlock &&
            <div className={this.state.displayAskBlock ? 'leaveGroup_rectangle' : 'leaveGroup_rectangle_hiden'}>
              <div className='leaveGroup_rectangle_2'>
                <div className='leaveGroup_rectangle_2_1'>
                  <div className='leaveGroup_title'> {([0, 2].indexOf(this.state.isBlocked) !== -1) ? translate('Block contact') : translate('Unblock contact')}</div>
                  <div className='leaveGroup_body'>{([0, 2].indexOf(this.state.isBlocked) !== -1) ?
                    translate('Are you sure you want to block this contact, you and this person will not be able to make calls or send messages') :
                    translate('Are you sure you want to unblock this contact')}</div>
                  <div className='leaveGroup_btnPlace'>
                    <div className='leaveGroup_cancelBtn' onClick={e => { this.setState({ displayAskBlock: false }) }} >{translate('Cancel')}</div>
                    <div className='leaveGroup_okBtn' onClick={e => this.onClickBlockContact()}>{translate('Accept')}</div>
                  </div>
                </div>
              </div>
            </div>
          }
          {
            this.state.flagPollList &&
            <RxPollList backBtnClick={() => { this.showListPoll(false) }} group_id={this.state.group.group_id} token={this.token} />
          }
        </div>
        {this.state.doneBtnClick &&
          <div className={this.state.doneBtnClick === true ? 'edit_rectangle' : 'edit_rectangle_hiden'} >
            <div className='edit_rectangle_1'>
              <div className='zmore-header'>
                <div className='zmore-btn-back_place' onClick={e => this.backBtnClickGroup()}>
                  <i className='icon-arrow-left' ></i>
                </div>
                <div className='edit-img-user' onClick={(e) => { rxaget(group, 'type', 0) !== 3 && this.refs.data_image.click() }}>
                  <input type='file' id='data_image' ref='data_image' multiple={false} key={this.state.theInputFileKey + '_data_image'}
                    style={{ display: 'none' }}
                    onChange={(e) => this.uploadFileImages(e.target.files)} accept="image/jpg,image/png,video/mp4" />
                  {rxaget(group, 'type', 0) !== 3 && <div className="icon-camera"></div>}
                  {(checkAvatarGroup(this.state.group, this.users, this.userid)) && <>
                    <img src={this.loadImgStatic(this.state.group, 'group')} alt=''
                      className={'account-ava-group images-static' + (rxaget(group, 'type', 0) !== 3 ? " edit" : "")}
                      onError={(e) => { e.target.onerror = null; e.target.src = './images/default/static/avadefault.svg' }} />
                    <img src={this.loadImgStatic(this.state.group, 'group', global.rxu.config.get_static)} alt=''
                      className={'account-ava-group images-static' + (rxaget(group, 'type', 0) !== 3 ? " edit" : "")}
                      onError={(e) => { e.target.onerror = null; e.target.src = './images/default/static/avadefault.svg' }} />
                  </>}
                  {!(this.state.group.avatar_url || (this.users[this.state.group.partner_id] && this.users[this.state.group.partner_id]['profile_url'])) &&
                    <span className={'account-ava-span' + (rxaget(group, 'type', 0) !== 3 ? " edit" : "")} style={{ background: `${changeColorAva(rxaget(this.state.group, 'group_id', ''))}` }}>{textAva(rxChangeSlug(checkNameGroup(this.state.group, this.users, this.userid)))}</span>
                  }
                </div>
                <div className='rxAccount-btn-done'>
                  <span className='rxAccount-txt-done' onClick={e => this.doneAccountInfo()}>
                    {translate('Done')}
                  </span>
                </div>
              </div>
              <div className='rxAccount_group_name_place'>
                <div className='rxAccount_group_name_title'>{(rxaget(group, 'type', 0) !== 3) ? translate('Group name') : translate('Full name')}</div>
                <input maxLength='30' className='rxAccount_group_name_input' placeholder={translate('Edit name')}
                  value={this.state.groupNameValue}
                  onChange={(event) => this.setState({ groupNameValue: event.target.value })} ></input>
                <div className='edit_divider'></div>
              </div>
              {(rxaget(group, 'type', 0) === 4) && <div className='rxAccount_group_name_desc'>
                <div className='rxAccount_group_name_title'>{translate('Description')}</div>
                <textarea
                  maxLength='150'
                  className='rxAccount_group_desc_input'
                  placeholder={translate('Describe with 150 characters')}
                  value={this.state.groupDescValue}
                  onChange={(event) => this.setState({ groupDescValue: event.target.value })}
                >
                </textarea>
              </div>}
              {(rxaget(group, 'type', 0) !== 3 && this.state.groupLink) && <div className='rxAccount_group_name_place'>
                <div className='rxAccount_group_name_title'>{translate('Share Group\'s Link')}</div>
                <div className='rxAccount_group_name_input'>{this.state.groupLink}</div>
                <div className='edit_divider'></div>
                <div className='rxAccount_group_btn_revoke' onClick={e => this.btnRevokeLink()}>{translate('Revoke Link')}</div>
              </div>}
              {(this.userid.toString() === rxaget(group, 'owner_uin', '').toString()) && <div className={(rxaget(group, 'type', 0) !== 3) ? 'rxAccount_btn_newManager' : 'rxAccount_btn_newManager_hiden'} onClick={e => this.openNewManager()}>{translate('Choose owner')}</div>}
              <div className={(rxaget(group, 'type', 0) !== 3) ? 'rxAccount_btn_newManager' : 'rxAccount_btn_newManager_hiden'} onClick={e => this.openAddAdminManager()}>{translate('Add new admininistrator')}</div>
              <div className={(rxaget(group, 'type', 0) !== 3) ? 'rxAccount_btn_newManager' : 'rxAccount_btn_newManager_hiden'} onClick={e => this.openListManager()}>{translate('List of admininistrators')}</div>
            </div>
          </div>
        }
        {this.state.closeBtnClick &&
          <div className={this.state.closeBtnClick === true ? 'newManager_rectangle' : 'newManager_rectangle_hiden'}>
            <div className='newManager_rectangle_1'>
              <div className='newManager_title_place'>
                <div className='newManager_title'>{translate('Choose owner')}</div>
                <div className='newManager_btn_close'>
                  <img className='newManager_icon_close filter_img_class' src={changeColorSVG('./images/default/icons/icon-basic-up.svg')} alt="" onClick={e => this.closeNewManager()} />
                </div>
              </div>
              <div className='newgroup_searchwrap'>
                <div className='newgroup_icon_search_area'>
                  <img className='newgroup_icon_search_search filter_img_class' src={changeColorSVG('./images/default/icons/search-active.svg')} alt='' />
                </div>
                <input type='search' placeholder={translate('Search')} maxLength='30' className={zget(this.props, 'themeBackgroudValue') === 'darkTheme' ? 'newgroup_search_place darkThemeInput' : 'newgroup_search_place lightThemeInput'} onChange={e => { this.onChangeSearch_chooseLeader(e) }} onDrop={this.disableDrop}></input>
              </div>
              <div className='selectManager_contactlist' id='zgroup_list' onScroll={this.scrollGroupChat}>
                <ChooseLeaderContactList />
              </div>
              <div className='chooseLeader_okBtn_area'>
                <div className='chooseLeader_okBtn' onClick={e => this.chooseLeader_okBtnClick()}>{translate('Done')}</div>
              </div>
            </div>
          </div>
        }
        {this.state.flagShowPopupAddAdmin &&
          <div className='newManager_rectangle'>
            <div className='newManager_rectangle_1'>
              <div className='newManager_title_place'>
                <div className='newManager_title'>{translate('Add new admininistrator')}</div>
                <div className='newManager_btn_close'>
                  <img className='newManager_icon_close filter_img_class' src={changeColorSVG('./images/default/icons/icon-basic-up.svg')} alt="" onClick={e => this.closeAddAdminManager()} />
                </div>
              </div>
              <div className='newgroup_searchwrap'>
                <div className='newgroup_icon_search_area'>
                  <img className='newgroup_icon_search_search filter_img_class' src={changeColorSVG('./images/default/icons/search-active.svg')} alt='' />
                </div>
                <input type='search' placeholder={translate('Search')} maxLength='30' className={zget(this.props, 'themeBackgroudValue') === 'darkTheme' ? 'newgroup_search_place darkThemeInput' : 'newgroup_search_place lightThemeInput'} onChange={e => { this.onChangeSearch_chooseLeader(e) }} onDrop={this.disableDrop}></input>
              </div>
              <div className='selectManager_contactlist' id='zgroup_list' onScroll={this.scrollGroupChat}>
                <VariableSizeList
                  className="selectManager_contactlist"
                  height={heightLeaderContactList}
                  itemCount={chooseLeaderItemCount}
                  itemSize={getItemSize}
                  width={300}
                >
                  {ChooseAdminRow}
                </VariableSizeList>
              </div>
              <div className='chooseLeader_okBtn_area'>
                <div className='chooseLeader_okBtn' onClick={e => this.onClickAddAdminMember()}>{translate('Done')}</div>
              </div>
            </div>
          </div>
        }
        {this.state.flagShowListAdmin &&
          <div className='newManager_rectangle'>
            <div className='newManager_rectangle_1'>
              <div className='newManager_title_place'>
                <div className='newManager_title'>{translate('List of admininistrators')}</div>
                <div className='newManager_btn_close'>
                  <img className='newManager_icon_close filter_img_class' src={changeColorSVG('./images/default/icons/icon-basic-up.svg')} alt="" onClick={e => this.closeListManager()} />
                </div>
              </div>
              <div className='' id='zgroup_list' onScroll={this.scrollGroupChat}>
                <ListAdminsComponent />
              </div>

            </div>
          </div>
        }
      </Fragment>
    )
  }
}

const mapStateToProps = (state, ownProps) => ({
  themeValue: state.themeValue,
  themeBackgroudValue: state.themeBackgroudValue,
  user: state.user,
  netaauth: state.netaauth,
  rxgroup: state.rxgroup,
  netaGroups: state.netaGroups,
  netaMedia: state.netaMedia,
  netaContact: state.netaContact,
  usersStatus: state.usersStatus,
  langValue: state.langValue,
  rxPollListState: state.rxPollListState
})

const mapDispatchToProps = {
  netaMediaAdd,
  netaMediaDelMulti,
  changeStatusLoadMess,
  chooseGroupAction,
  netaGroupsUpdate,
  netaAuthSettingUpdate,
  netaAuthSettingSoundUpdate,
  netaGroupsRemove,
  updateRecentContactGroups,
  clickCall,
  clickPopup,
  changeGroupFunc,
  updateRecentSearchGroups,
  updateListPollState
}

const RxAccountInfoWrap = connect(
  mapStateToProps,
  mapDispatchToProps
)(RxAccountInfo)

export default RxAccountInfoWrap